// Translation pack for the smart "Nuovo Cliente" wizard in the Dealer Portal.
// 18 European country codes (CH/GBZ/IRL/BE fall back to similar locales).
// All strings are de-accented (no diacritics) per the platform convention
// for legacy PDF/printer compatibility.

const DEALER_FORM_I18N = {
  IT: {
    reset: "Reset campi", exit: "Esci",
    // Anti-typo double-confirmation fields (Req. Fabrizio 22/02/2026)
    emailConfirmLabel: "Conferma email (ridigita)*",
    emailConfirmPlaceholder: "Ridigita l\u2019indirizzo email",
    emailConfirmOk: "\u2713 Le email corrispondono",
    emailConfirmMismatch: "\u26A0 Le email non corrispondono",
    phoneConfirmLabel: "Conferma cellulare (ridigita)*",
    phoneConfirmPlaceholder: "Ridigita il numero",
    phoneConfirmOk: "\u2713 I numeri corrispondono",
    phoneConfirmMismatch: "\u26A0 I numeri non corrispondono",
    resetConfirm: "Vuoi davvero svuotare tutti i campi compilati?",
    exitConfirm: "Uscire dal form? Le modifiche non salvate andranno perse.",
    dealerFormSubtitle: "I campi si attivano in sequenza man mano che li compili.",
    creatingCustomerIn: "Stai creando un cliente in",
    changeCountry: "Cambia paese",
    customerCountry: "Paese del cliente",
    recent: "Recenti",
    recentCountries: "Paesi recenti",
    allCountries: "Tutti i paesi",
    confirm: "OK",
    customerType: "Tipo Cliente",
    private: "Privato",
    business: "Azienda",
    privateIdentity: "Dati anagrafici",
    businessIdentity: "Dati aziendali",
    companyName: "Ragione Sociale",
    formatHint: "Formato",
    vehicleData: "Dati Veicolo",
    vinSuggestion: "Suggerimento da NHTSA (VIN)",
    vinAutoApplied: "Veicolo riconosciuto · compilato automaticamente",
    vinEditable: "I campi Marca e Modello sono comunque modificabili.",
    vrnOptional: "Campo facoltativo",
    vinNotRecognised: "VIN non riconosciuto da NHTSA — inserisci marca e modello a mano.",
    vinDecodeFailed: "Servizio decodifica VIN momentaneamente non disponibile",
    vinApplied: "Marca e modello popolati dal VIN",
    apply: "Applica",
    ignore: "Ignora",
    viesTooltip: "Verifica online tramite VIES UE",
    viesFound: "Dati aziendali trovati su VIES",
    viesNotFound: "P.IVA non trovata su VIES",
    viesNotSupported: "VIES disponibile solo per i paesi UE",
    viesUnavailable: "Servizio VIES temporaneamente non disponibile",
    viesApplied: "Dati VIES applicati al form",
    viesError: "Errore verifica VIES",
    vatRequiredFirst: "Inserisci prima la P.IVA",
    vatCountryMismatchTitle: "P.IVA di un altro paese rilevata",
    vatCountryMismatchBody: "Il prefisso della P.IVA indica un cliente {detected}, ma il paese del cliente è attualmente {current}. Vuoi aggiornarlo?",
    vatCountrySwitchTo: "Imposta paese su {detected}",
    vatCountrySwitchedTo: "Paese cliente aggiornato:",
    phoneCountryMismatchTitle: "Numero di un altro paese rilevato",
    phoneCountryMismatchBody: "Il prefisso telefonico indica un cliente {detected}, ma il paese del cliente è attualmente {current}. Vuoi aggiornarlo?",
    phoneCountrySwitchTo: "Imposta paese su {detected}",
    phoneCountrySwitchedTo: "Paese cliente aggiornato:",
    completeAllSteps: "Compila tutti i campi richiesti per continuare",
    vinValidOk: "VIN valido (checksum OK)",
    vinValidEU: "Formato VIN valido (UE)",
    vinSuspiciousRun: "VIN sospetto: troppi caratteri identici consecutivi",
    vinChecksumFail: "Checksum VIN non valido: la cifra di controllo in posizione 9 non corrisponde",
    vinForbiddenChar: "VIN contiene caratteri non consentiti (I, O, Q)",
    vinBadLength: "VIN deve essere di 17 caratteri",
    vinVerified: "VIN verificato (NHTSA)",
    vinCheckDigitMismatch: "Cifra di controllo non corrisponde",
    vehicleOriginLabel: "Veicolo",
    differentFromCustomer: "paese diverso dal cliente",
    vehicleCountryMismatchTitle: "Paese veicolo (",
    vehicleCountryMismatchVsCustomer: ") diverso da paese cliente ("
  ,
    taxCodeUiLabel: "Codice Fiscale",
    vatNumberUiLabel: "Partita IVA",
    validSuffix: "valido",
    // CF Calculator (Fabrizio 27/07/2026)
    cfCalcOpen: "Calcola CF",
    cfCalcOpenTitle: "Calcola il Codice Fiscale a partire dai dati anagrafici del cliente",
    cfCalcApplied: "Codice Fiscale applicato dal calcolatore",
    optional: "Opzionale",
    customerEmailLabel: "Email cliente",
    vinChassisLabel: "VIN (Telaio)",
    vrnPlateLabel: "VRN (Targa)",
    brandLabel: "Marca",
    modelLabel: "Modello",
    confirmDeleteCustomer: "Eliminare il cliente {name} ({email})?",
    customerDeletedSuccess: "Cliente eliminato",
    customerDeleteError: "Errore eliminazione cliente",
    enterValidNumber: "Inserisci un numero valido",
    viewSignedReadonly: "Visualizza dati (firmato, sola lettura)",
    editCustomer: "Modifica cliente",
    deleteCustomerOnlyUnsigned: "Elimina cliente (solo se non firmato)",
    deactivateAction: "Disattiva",
    activateAction: "Attiva",
    deleteAction: "Elimina",
    salesTeamPlaceholder: "es. Vendite Nord",
    thisMonth: "Questo Mese",
    last7days: "Ultimi 7gg",
    last30daysShort: "Ultimi 30gg",
    last6MonthsTrend: "Trend Ultimi 6 Mesi",
    topPerformerOfMonth: "Top Performer del Mese",
    monthHeader: "Mese",
    networkSummary: "Riepilogo Rete",
    globalMonthlyTarget: "Obiettivo Mensile Globale",
  
    mismatchTitle: "Clienti con paese da rivedere",
    mismatchBodyIntro: "Negli ultimi 30 giorni hai creato",
    mismatchBodyMiddle: "clienti, di cui",
    mismatchBodyEnd: "hanno un paese diverso da quello suggerito da P.IVA o prefisso telefonico. Correggi con un click.",
    mismatchCleanTitle: "Qualità dati paese: ✅ Ottimo lavoro",
    mismatchCleanBody: "Tutti i {n} clienti degli ultimi 30 giorni hanno il paese coerente con P.IVA/telefono.",
    mismatchCurrent: "Attuale:",
    mismatchSourceVat: "da P.IVA",
    mismatchSourcePhone: "da telefono",
    mismatchFixBtn: "Correggi",
    mismatchConfirmQuestion: "Conferma cambio paese a",
    mismatchReasonPlaceholder: "Motivo correzione (opzionale)",
    mismatchSaving: "Salvataggio...",
    mismatchConfirmFix: "Conferma correzione",
    mismatchCancel: "Annulla",
    mismatchCountryUpdated: "Paese aggiornato:",
    mismatchCorrectionFailed: "Errore correzione",
    mismatchCorrectionReasonDefault: "Corretto dal widget Mismatch (dealer)",
    cannotDeleteContractSigned: "Impossibile eliminare: contratto già firmato",
    resendActivationEmail: "Re-invia email attivazione",
  
    fpSessionInvalid: "Sessione non valida",
    fpMissingToken: "Token di accesso mancante.",
    fpBackToLogin: "Torna al login",
    fpPasswordTooShort: "La nuova password deve avere almeno 10 caratteri.",
    fpPasswordsMismatch: "Le password non coincidono.",
    fpSameAsTemp: "La nuova password non puo coincidere con quella temporanea.",
    fpSuccess: "Password aggiornata. Effettua di nuovo il login.",
    fpUpdateFailed: "Impossibile aggiornare la password.",
    fpTitle: "Crea la tua password personale",
    fpSubtitle: "Al primo accesso devi sostituire la password temporanea ricevuta via email con una nuova password personale.",
    fpTempLabel: "Password temporanea (quella ricevuta via email)",
    fpNewLabel: "Nuova password (min. 10 caratteri)",
    fpConfirmLabel: "Conferma nuova password",
    fpUpdating: "Aggiornamento…",
    fpSetBtn: "Imposta nuova password",
    fpSecurityNotice: "Per motivi di sicurezza, al termine ti verrà richiesto di effettuare di nuovo il login con la nuova password.",
    sellerCreditedLabel: "Venditore associato",
    sellerCreditedPlaceholder: "Seleziona il venditore...",
    sellerCreditedManagerSuffix: "Titolare",
    sellerCreditedHintNoSellers: "Non hai ancora aggiunto venditori. Puoi attribuire questo cliente a te stesso oppure crearne uno dal tab \"Venditori\".",
    backOfficeUserLabel: "Utenza Back-Office (personale amministrativo)",
    backOfficeUserHint: "L'utenza Back-Office puo' inserire clienti per conto dei venditori e monitorare tutti i contratti, ma non appare nel dropdown \"Venditore associato\" ne' vede statistiche di performance.",
    createBackOffice: "Crea Back-Office",
  },
  UK: {
    reset: "Reset fields", exit: "Exit",
    // Anti-typo double-confirmation fields (Req. Fabrizio 22/02/2026)
    emailConfirmLabel: "Confirm email (retype)*",
    emailConfirmPlaceholder: "Retype the email address",
    emailConfirmOk: "\u2713 Emails match",
    emailConfirmMismatch: "\u26A0 Emails do not match",
    phoneConfirmLabel: "Confirm mobile (retype)*",
    phoneConfirmPlaceholder: "Retype the phone number",
    phoneConfirmOk: "\u2713 Phone numbers match",
    phoneConfirmMismatch: "\u26A0 Phone numbers do not match",
    resetConfirm: "Do you really want to clear all entered fields?",
    exitConfirm: "Exit the form? Unsaved changes will be lost.",
    dealerFormSubtitle: "Fields activate progressively as you fill them in.",
    creatingCustomerIn: "You are creating a customer in",
    changeCountry: "Change country",
    customerCountry: "Customer country",
    recent: "Recent",
    recentCountries: "Recent countries",
    allCountries: "All countries",
    confirm: "OK",
    customerType: "Customer Type",
    private: "Individual",
    business: "Company",
    privateIdentity: "Personal details",
    businessIdentity: "Company details",
    companyName: "Company Name",
    formatHint: "Format",
    vehicleData: "Vehicle data",
    vinSuggestion: "NHTSA suggestion (from VIN)",
    vinAutoApplied: "Vehicle recognised · filled automatically",
    vinEditable: "Make and Model are still editable.",
    vrnOptional: "Optional",
    vinNotRecognised: "VIN not recognised by NHTSA — please enter make and model manually.",
    vinDecodeFailed: "VIN decoding service temporarily unavailable",
    vinApplied: "Make and model filled from VIN",
    apply: "Apply",
    ignore: "Ignore",
    viesTooltip: "Verify online via EU VIES",
    viesFound: "Company data found on VIES",
    viesNotFound: "VAT number not found on VIES",
    viesNotSupported: "VIES available only for EU countries",
    viesUnavailable: "VIES service temporarily unavailable",
    viesApplied: "VIES data applied to the form",
    viesError: "VIES verification error",
    vatRequiredFirst: "Please enter the VAT number first",
    vatCountryMismatchTitle: "Foreign VAT number detected",
    vatCountryMismatchBody: "The VAT prefix indicates a {detected} customer, but the customer country is currently set to {current}. Would you like to update it?",
    vatCountrySwitchTo: "Set country to {detected}",
    vatCountrySwitchedTo: "Customer country updated:",
    phoneCountryMismatchTitle: "Foreign phone number detected",
    phoneCountryMismatchBody: "The phone dial code indicates a {detected} customer, but the customer country is currently set to {current}. Would you like to update it?",
    phoneCountrySwitchTo: "Set country to {detected}",
    phoneCountrySwitchedTo: "Customer country updated:",
    completeAllSteps: "Fill in all required fields to continue",
    vinValidOk: "Valid VIN (checksum OK)",
    vinValidEU: "Valid VIN format (EU)",
    vinSuspiciousRun: "Suspicious VIN: too many identical consecutive characters",
    vinChecksumFail: "Invalid VIN checksum: position 9 check digit does not match",
    vinForbiddenChar: "VIN contains forbidden characters (I, O, Q)",
    vinBadLength: "VIN must be 17 characters",
    vinVerified: "VIN verified (NHTSA)",
    vinCheckDigitMismatch: "Check digit mismatch",
    vehicleOriginLabel: "Vehicle",
    differentFromCustomer: "country differs from customer",
    vehicleCountryMismatchTitle: "Vehicle country (",
    vehicleCountryMismatchVsCustomer: ") differs from customer country ("
  ,
    taxCodeUiLabel: "Tax Code",
    vatNumberUiLabel: "VAT Number",
    validSuffix: "valid",
    // CF Calculator (Fabrizio 27/07/2026)
    cfCalcOpen: "Calculate CF",
    cfCalcOpenTitle: "Calculate the Codice Fiscale from customer identity data",
    cfCalcApplied: "Codice Fiscale applied from calculator",
    optional: "Optional",
    customerEmailLabel: "Customer email",
    vinChassisLabel: "VIN (Chassis)",
    vrnPlateLabel: "VRN (Plate)",
    brandLabel: "Brand",
    modelLabel: "Model",
    confirmDeleteCustomer: "Delete customer {name} ({email})?",
    customerDeletedSuccess: "Customer deleted",
    customerDeleteError: "Error deleting customer",
    enterValidNumber: "Please enter a valid number",
    viewSignedReadonly: "View data (signed, read-only)",
    editCustomer: "Edit customer",
    deleteCustomerOnlyUnsigned: "Delete customer (only if unsigned)",
    deactivateAction: "Deactivate",
    activateAction: "Activate",
    deleteAction: "Delete",
    salesTeamPlaceholder: "e.g. North Sales",
    thisMonth: "This Month",
    last7days: "Last 7 days",
    last30daysShort: "Last 30 days",
    last6MonthsTrend: "Last 6 Months Trend",
    topPerformerOfMonth: "Top Performer of the Month",
    monthHeader: "Month",
    networkSummary: "Network Summary",
    globalMonthlyTarget: "Global Monthly Target",
  
    mismatchTitle: "Customers with country to review",
    mismatchBodyIntro: "In the last 30 days you created",
    mismatchBodyMiddle: "customers, of which",
    mismatchBodyEnd: "have a country different from the one suggested by VAT or phone prefix. Fix with one click.",
    mismatchCleanTitle: "Country data quality: ✅ Great job",
    mismatchCleanBody: "All {n} customers from the last 30 days have a country consistent with VAT/phone.",
    mismatchCurrent: "Current:",
    mismatchSourceVat: "from VAT",
    mismatchSourcePhone: "from phone",
    mismatchFixBtn: "Fix",
    mismatchConfirmQuestion: "Confirm country change to",
    mismatchReasonPlaceholder: "Correction reason (optional)",
    mismatchSaving: "Saving...",
    mismatchConfirmFix: "Confirm correction",
    mismatchCancel: "Cancel",
    mismatchCountryUpdated: "Country updated:",
    mismatchCorrectionFailed: "Correction error",
    mismatchCorrectionReasonDefault: "Fixed via Mismatch widget (dealer)",
    cannotDeleteContractSigned: "Cannot delete: contract already signed",
    resendActivationEmail: "Resend activation email",
  
    fpSessionInvalid: "Invalid session",
    fpMissingToken: "Access token missing.",
    fpBackToLogin: "Back to login",
    fpPasswordTooShort: "The new password must be at least 10 characters long.",
    fpPasswordsMismatch: "Passwords do not match.",
    fpSameAsTemp: "The new password cannot match the temporary one.",
    fpSuccess: "Password updated. Please log in again.",
    fpUpdateFailed: "Unable to update password.",
    fpTitle: "Create your personal password",
    fpSubtitle: "On first login you must replace the temporary password received by email with a new personal password.",
    fpTempLabel: "Temporary password (the one received via email)",
    fpNewLabel: "New password (min. 10 characters)",
    fpConfirmLabel: "Confirm new password",
    fpUpdating: "Updating…",
    fpSetBtn: "Set new password",
    fpSecurityNotice: "For security reasons, you will be asked to log in again with the new password.",
    sellerCreditedLabel: "Credited seller",
    sellerCreditedPlaceholder: "Select the seller...",
    sellerCreditedManagerSuffix: "Owner",
    sellerCreditedHintNoSellers: "You have not added any sellers yet. You can credit this customer to yourself or create a seller from the \"Sellers\" tab.",
    backOfficeUserLabel: "Back-Office user (administrative staff)",
    backOfficeUserHint: "Back-Office users can create customers on behalf of sellers and monitor all contracts, but they do not appear in the \"Credited seller\" dropdown and have no performance stats.",
    createBackOffice: "Create Back-Office",
  },
  FR: {
    reset: "Effacer les champs", exit: "Quitter",
    // Anti-typo double-confirmation fields (Req. Fabrizio 22/02/2026)
    emailConfirmLabel: "Confirmer l\u2019email (retaper)*",
    emailConfirmPlaceholder: "Retapez l\u2019adresse email",
    emailConfirmOk: "\u2713 Les emails correspondent",
    emailConfirmMismatch: "\u26A0 Les emails ne correspondent pas",
    phoneConfirmLabel: "Confirmer le mobile (retaper)*",
    phoneConfirmPlaceholder: "Retapez le numero de telephone",
    phoneConfirmOk: "\u2713 Les numeros correspondent",
    phoneConfirmMismatch: "\u26A0 Les numeros ne correspondent pas",
    resetConfirm: "Voulez-vous vraiment vider tous les champs?",
    exitConfirm: "Quitter le formulaire? Les modifications non enregistrees seront perdues.",
    dealerFormSubtitle: "Les champs s'activent progressivement au fur et a mesure que vous les remplissez.",
    creatingCustomerIn: "Vous creez un client en",
    changeCountry: "Changer de pays",
    customerCountry: "Pays du client",
    recent: "Recents",
    recentCountries: "Pays recents",
    allCountries: "Tous les pays",
    confirm: "OK",
    customerType: "Type de client",
    private: "Particulier",
    business: "Entreprise",
    privateIdentity: "Donnees personnelles",
    businessIdentity: "Donnees de l'entreprise",
    companyName: "Raison sociale",
    formatHint: "Format",
    vehicleData: "Donnees du vehicule",
    vinSuggestion: "Suggestion NHTSA (VIN)",
    vinNotRecognised: "VIN non reconnu par NHTSA — veuillez saisir la marque et le modele manuellement.",
    vinDecodeFailed: "Service de decodage VIN momentanement indisponible",
    vinApplied: "Marque et modele remplis depuis le VIN",
    apply: "Appliquer",
    ignore: "Ignorer",
    viesTooltip: "Verification en ligne via VIES UE",
    viesFound: "Donnees de l'entreprise trouvees sur VIES",
    viesNotFound: "Numero de TVA introuvable sur VIES",
    viesNotSupported: "VIES disponible uniquement pour les pays de l'UE",
    viesUnavailable: "Service VIES momentanement indisponible",
    viesApplied: "Donnees VIES appliquees au formulaire",
    viesError: "Erreur de verification VIES",
    vatRequiredFirst: "Veuillez d'abord saisir le numero de TVA",
    completeAllSteps: "Remplissez tous les champs requis pour continuer",
    vinValidOk: "VIN valide (checksum OK)",
    vinValidEU: "Format VIN valide (UE)",
    vinSuspiciousRun: "VIN suspect : trop de caracteres identiques consecutifs",
    vinChecksumFail: "Checksum VIN invalide : la cifra de controle en position 9 ne correspond pas",
    vinForbiddenChar: "Le VIN contient des caracteres non autorises (I, O, Q)",
    vinBadLength: "Le VIN doit avoir 17 caracteres",
    vinVerified: "VIN verifie (NHTSA)",
    vinCheckDigitMismatch: "Cifra de controle non concordante",
    vehicleOriginLabel: "Vehicule",
    differentFromCustomer: "pays different du client",
    vehicleCountryMismatchTitle: "Pays du vehicule (",
    vehicleCountryMismatchVsCustomer: ") different du pays du client (",
  
    taxCodeUiLabel: "Code fiscal",
    vatNumberUiLabel: "Numero TVA",
    validSuffix: "valide",
    optional: "Optionnel",
    customerEmailLabel: "E-mail du client",
    vinChassisLabel: "VIN (Chassis)",
    vrnPlateLabel: "VRN (Plaque)",
    brandLabel: "Marque",
    modelLabel: "Modele",
    confirmDeleteCustomer: "Supprimer le client {name} ({email})?",
    customerDeletedSuccess: "Client supprime",
    customerDeleteError: "Erreur lors de la suppression du client",
    enterValidNumber: "Veuillez saisir un nombre valide",
    viewSignedReadonly: "Voir les donnees (signe, lecture seule)",
    editCustomer: "Modifier le client",
    deleteCustomerOnlyUnsigned: "Supprimer le client (uniquement si non signe)",
    deactivateAction: "Desactiver",
    activateAction: "Activer",
    deleteAction: "Supprimer",
    salesTeamPlaceholder: "ex. Ventes Nord",
    thisMonth: "Ce mois-ci",
    last7days: "7 derniers jours",
    last30daysShort: "30 derniers jours",
    last6MonthsTrend: "Tendance des 6 derniers mois",
    topPerformerOfMonth: "Meilleur performeur du mois",
    monthHeader: "Mois",
    networkSummary: "Resume du reseau",
    globalMonthlyTarget: "Objectif mensuel global",
  
    mismatchTitle: "Clients avec pays a verifier",
    mismatchBodyIntro: "Au cours des 30 derniers jours, vous avez cree",
    mismatchBodyMiddle: "clients, dont",
    mismatchBodyEnd: "ont un pays different de celui suggere par la TVA ou le prefixe telephonique. Corrigez en un clic.",
    mismatchCleanTitle: "Qualite des donnees pays : ✅ Excellent travail",
    mismatchCleanBody: "Tous les {n} clients des 30 derniers jours ont un pays coherent avec TVA/telephone.",
    mismatchCurrent: "Actuel :",
    mismatchSourceVat: "depuis TVA",
    mismatchSourcePhone: "depuis telephone",
    mismatchFixBtn: "Corriger",
    mismatchConfirmQuestion: "Confirmer le changement de pays a",
    mismatchReasonPlaceholder: "Raison de la correction (optionnel)",
    mismatchSaving: "Enregistrement...",
    mismatchConfirmFix: "Confirmer la correction",
    mismatchCancel: "Annuler",
    mismatchCountryUpdated: "Pays mis a jour :",
    mismatchCorrectionFailed: "Erreur de correction",
    mismatchCorrectionReasonDefault: "Corrige via widget Mismatch (concessionnaire)",
    cannotDeleteContractSigned: "Impossible de supprimer : contrat deja signe",
    resendActivationEmail: "Renvoyer l'email d'activation",
  
    fpSessionInvalid: "Session invalide",
    fpMissingToken: "Token d'acces manquant.",
    fpBackToLogin: "Retour a la connexion",
    fpPasswordTooShort: "Le nouveau mot de passe doit comporter au moins 10 caracteres.",
    fpPasswordsMismatch: "Les mots de passe ne correspondent pas.",
    fpSameAsTemp: "Le nouveau mot de passe ne peut pas etre identique au temporaire.",
    fpSuccess: "Mot de passe mis a jour. Veuillez vous reconnecter.",
    fpUpdateFailed: "Impossible de mettre a jour le mot de passe.",
    fpTitle: "Creez votre mot de passe personnel",
    fpSubtitle: "Lors de votre premiere connexion, vous devez remplacer le mot de passe temporaire recu par email par un nouveau mot de passe personnel.",
    fpTempLabel: "Mot de passe temporaire (celui recu par email)",
    fpNewLabel: "Nouveau mot de passe (min. 10 caracteres)",
    fpConfirmLabel: "Confirmez le nouveau mot de passe",
    fpUpdating: "Mise a jour…",
    fpSetBtn: "Definir le nouveau mot de passe",
    fpSecurityNotice: "Pour des raisons de securite, il vous sera demande de vous reconnecter avec le nouveau mot de passe.",
    sellerCreditedLabel: "Vendeur attribue",
    sellerCreditedPlaceholder: "Selectionnez le vendeur...",
    sellerCreditedManagerSuffix: "Titulaire",
    sellerCreditedHintNoSellers: "Vous n'avez pas encore ajoute de vendeurs. Vous pouvez attribuer ce client a vous-meme ou en creer un depuis l'onglet \"Vendeurs\".",
    backOfficeUserLabel: "Utilisateur Back-Office (personnel administratif)",
    backOfficeUserHint: "L'utilisateur Back-Office peut creer des clients pour le compte des vendeurs et suivre tous les contrats, mais il n'apparait pas dans le menu \"Vendeur attribue\" et n'a pas de statistiques de performance.",
    createBackOffice: "Creer Back-Office",
  },
  ES: {
    reset: "Borrar campos", exit: "Salir",
    // Anti-typo double-confirmation fields (Req. Fabrizio 22/02/2026)
    emailConfirmLabel: "Confirmar email (reescribe)*",
    emailConfirmPlaceholder: "Reescribe la direccion de correo",
    emailConfirmOk: "\u2713 Los emails coinciden",
    emailConfirmMismatch: "\u26A0 Los emails no coinciden",
    phoneConfirmLabel: "Confirmar movil (reescribe)*",
    phoneConfirmPlaceholder: "Reescribe el numero de telefono",
    phoneConfirmOk: "\u2713 Los numeros coinciden",
    phoneConfirmMismatch: "\u26A0 Los numeros no coinciden",
    resetConfirm: "Quieres realmente vaciar todos los campos?",
    exitConfirm: "Salir del formulario? Los cambios no guardados se perderan.",
    dealerFormSubtitle: "Los campos se activan progresivamente a medida que los rellenas.",
    creatingCustomerIn: "Estas creando un cliente en",
    changeCountry: "Cambiar pais",
    customerCountry: "Pais del cliente",
    recent: "Recientes",
    recentCountries: "Paises recientes",
    allCountries: "Todos los paises",
    confirm: "OK",
    customerType: "Tipo de cliente",
    private: "Particular",
    business: "Empresa",
    privateIdentity: "Datos personales",
    businessIdentity: "Datos de la empresa",
    companyName: "Razon social",
    formatHint: "Formato",
    vehicleData: "Datos del vehiculo",
    vinSuggestion: "Sugerencia NHTSA (VIN)",
    vinNotRecognised: "VIN no reconocido por NHTSA — introduce marca y modelo manualmente.",
    vinDecodeFailed: "Servicio de decodificacion VIN no disponible temporalmente",
    vinApplied: "Marca y modelo completados desde el VIN",
    apply: "Aplicar",
    ignore: "Ignorar",
    viesTooltip: "Verificar online via VIES UE",
    viesFound: "Datos de la empresa encontrados en VIES",
    viesNotFound: "Numero de IVA no encontrado en VIES",
    viesNotSupported: "VIES disponible solo para paises de la UE",
    viesUnavailable: "Servicio VIES no disponible temporalmente",
    viesApplied: "Datos VIES aplicados al formulario",
    viesError: "Error de verificacion VIES",
    vatRequiredFirst: "Introduce primero el numero de IVA",
    completeAllSteps: "Rellena todos los campos obligatorios para continuar",
    vinValidOk: "VIN valido (checksum OK)",
    vinValidEU: "Formato VIN valido (UE)",
    vinSuspiciousRun: "VIN sospechoso: demasiados caracteres identicos consecutivos",
    vinChecksumFail: "Checksum VIN no valido: el digito de control en posicion 9 no coincide",
    vinForbiddenChar: "El VIN contiene caracteres no permitidos (I, O, Q)",
    vinBadLength: "El VIN debe tener 17 caracteres",
    vinVerified: "VIN verificado (NHTSA)",
    vinCheckDigitMismatch: "Digito de control no coincide",
    vehicleOriginLabel: "Vehiculo",
    differentFromCustomer: "pais distinto al del cliente",
    vehicleCountryMismatchTitle: "Pais del vehiculo (",
    vehicleCountryMismatchVsCustomer: ") distinto al pais del cliente ("
  ,
    taxCodeUiLabel: "Codigo fiscal",
    vatNumberUiLabel: "Numero de IVA",
    validSuffix: "valido",
    optional: "Opcional",
    customerEmailLabel: "Email del cliente",
    vinChassisLabel: "VIN (Chasis)",
    vrnPlateLabel: "VRN (Matricula)",
    brandLabel: "Marca",
    modelLabel: "Modelo",
    confirmDeleteCustomer: "Eliminar el cliente {name} ({email})?",
    customerDeletedSuccess: "Cliente eliminado",
    customerDeleteError: "Error al eliminar el cliente",
    enterValidNumber: "Introduce un numero valido",
    viewSignedReadonly: "Ver datos (firmado, solo lectura)",
    editCustomer: "Editar cliente",
    deleteCustomerOnlyUnsigned: "Eliminar cliente (solo si no firmado)",
    deactivateAction: "Desactivar",
    activateAction: "Activar",
    deleteAction: "Eliminar",
    salesTeamPlaceholder: "ej. Ventas Norte",
    thisMonth: "Este mes",
    last7days: "Ultimos 7 dias",
    last30daysShort: "Ultimos 30 dias",
    last6MonthsTrend: "Tendencia ultimos 6 meses",
    topPerformerOfMonth: "Top vendedor del mes",
    monthHeader: "Mes",
    networkSummary: "Resumen de la red",
    globalMonthlyTarget: "Objetivo mensual global",
  
    mismatchTitle: "Clientes con pais a revisar",
    mismatchBodyIntro: "En los ultimos 30 dias has creado",
    mismatchBodyMiddle: "clientes, de los cuales",
    mismatchBodyEnd: "tienen un pais diferente al sugerido por IVA o prefijo telefonico. Corrige con un clic.",
    mismatchCleanTitle: "Calidad de datos pais: ✅ Buen trabajo",
    mismatchCleanBody: "Todos los {n} clientes de los ultimos 30 dias tienen un pais coherente con IVA/telefono.",
    mismatchCurrent: "Actual:",
    mismatchSourceVat: "desde IVA",
    mismatchSourcePhone: "desde telefono",
    mismatchFixBtn: "Corregir",
    mismatchConfirmQuestion: "Confirmar cambio de pais a",
    mismatchReasonPlaceholder: "Motivo de la correccion (opcional)",
    mismatchSaving: "Guardando...",
    mismatchConfirmFix: "Confirmar correccion",
    mismatchCancel: "Cancelar",
    mismatchCountryUpdated: "Pais actualizado:",
    mismatchCorrectionFailed: "Error de correccion",
    mismatchCorrectionReasonDefault: "Corregido via widget Mismatch (distribuidor)",
    cannotDeleteContractSigned: "No se puede eliminar: contrato ya firmado",
    resendActivationEmail: "Reenviar email de activacion",
  
    fpSessionInvalid: "Sesion no valida",
    fpMissingToken: "Token de acceso ausente.",
    fpBackToLogin: "Volver al inicio de sesion",
    fpPasswordTooShort: "La nueva contrasena debe tener al menos 10 caracteres.",
    fpPasswordsMismatch: "Las contrasenas no coinciden.",
    fpSameAsTemp: "La nueva contrasena no puede coincidir con la temporal.",
    fpSuccess: "Contrasena actualizada. Vuelva a iniciar sesion.",
    fpUpdateFailed: "No se pudo actualizar la contrasena.",
    fpTitle: "Crea tu contrasena personal",
    fpSubtitle: "En tu primer inicio de sesion debes reemplazar la contrasena temporal recibida por correo con una nueva contrasena personal.",
    fpTempLabel: "Contrasena temporal (la recibida por correo)",
    fpNewLabel: "Nueva contrasena (min. 10 caracteres)",
    fpConfirmLabel: "Confirmar nueva contrasena",
    fpUpdating: "Actualizando…",
    fpSetBtn: "Establecer nueva contrasena",
    fpSecurityNotice: "Por motivos de seguridad, se te pedira que inicies sesion nuevamente con la nueva contrasena.",
    sellerCreditedLabel: "Vendedor asignado",
    sellerCreditedPlaceholder: "Selecciona el vendedor...",
    sellerCreditedManagerSuffix: "Titular",
    sellerCreditedHintNoSellers: "Aun no has anadido vendedores. Puedes asignar este cliente a ti mismo o crear uno desde la pestana \"Vendedores\".",
    backOfficeUserLabel: "Usuario Back-Office (personal administrativo)",
    backOfficeUserHint: "El usuario Back-Office puede dar de alta clientes por cuenta de los vendedores y monitorizar todos los contratos, pero no aparece en el menu \"Vendedor asignado\" ni tiene estadisticas de rendimiento.",
    createBackOffice: "Crear Back-Office",
  },
  DE: {
    reset: "Felder zurucksetzen", exit: "Verlassen",
    // Anti-typo double-confirmation fields (Req. Fabrizio 22/02/2026)
    emailConfirmLabel: "E-Mail bestatigen (erneut eingeben)*",
    emailConfirmPlaceholder: "E-Mail-Adresse erneut eingeben",
    emailConfirmOk: "\u2713 E-Mails stimmen uberein",
    emailConfirmMismatch: "\u26A0 E-Mails stimmen nicht uberein",
    phoneConfirmLabel: "Mobilnummer bestatigen (erneut eingeben)*",
    phoneConfirmPlaceholder: "Telefonnummer erneut eingeben",
    phoneConfirmOk: "\u2713 Rufnummern stimmen uberein",
    phoneConfirmMismatch: "\u26A0 Rufnummern stimmen nicht uberein",
    resetConfirm: "Mochten Sie wirklich alle ausgefullten Felder leeren?",
    exitConfirm: "Formular verlassen? Nicht gespeicherte Anderungen gehen verloren.",
    dealerFormSubtitle: "Die Felder werden nacheinander aktiviert, sobald Sie sie ausfullen.",
    creatingCustomerIn: "Sie erstellen einen Kunden in",
    changeCountry: "Land andern",
    customerCountry: "Land des Kunden",
    recent: "Kurzlich",
    recentCountries: "Kurzlich verwendete Lander",
    allCountries: "Alle Lander",
    confirm: "OK",
    customerType: "Kundentyp",
    private: "Privatkunde",
    business: "Unternehmen",
    privateIdentity: "Personliche Daten",
    businessIdentity: "Unternehmensdaten",
    companyName: "Firmenname",
    formatHint: "Format",
    vehicleData: "Fahrzeugdaten",
    vinSuggestion: "NHTSA-Vorschlag (VIN)",
    vinNotRecognised: "VIN nicht von NHTSA erkannt — bitte Marke und Modell manuell eingeben.",
    vinDecodeFailed: "VIN-Decodierungsdienst vorubergehend nicht verfugbar",
    vinApplied: "Marke und Modell aus VIN ausgefullt",
    apply: "Anwenden",
    ignore: "Ignorieren",
    viesTooltip: "Online-Verifizierung uber EU-VIES",
    viesFound: "Unternehmensdaten in VIES gefunden",
    viesNotFound: "USt-IdNr. nicht in VIES gefunden",
    viesNotSupported: "VIES nur fur EU-Lander verfugbar",
    viesUnavailable: "VIES-Dienst vorubergehend nicht verfugbar",
    viesApplied: "VIES-Daten in Formular ubernommen",
    viesError: "VIES-Verifizierungsfehler",
    vatRequiredFirst: "Bitte zuerst USt-IdNr. eingeben",
    completeAllSteps: "Fullen Sie alle erforderlichen Felder aus, um fortzufahren",
    vinValidOk: "Gultige VIN (Prufsumme OK)",
    vinValidEU: "Gultiges VIN-Format (EU)",
    vinSuspiciousRun: "Verdachtige VIN: zu viele identische aufeinanderfolgende Zeichen",
    vinChecksumFail: "Ungultige VIN-Prufsumme: die Prufziffer in Position 9 stimmt nicht uberein",
    vinForbiddenChar: "VIN enthalt verbotene Zeichen (I, O, Q)",
    vinBadLength: "Die VIN muss 17 Zeichen lang sein",
    vinVerified: "VIN verifiziert (NHTSA)",
    vinCheckDigitMismatch: "Prufziffer stimmt nicht uberein",
    vehicleOriginLabel: "Fahrzeug",
    differentFromCustomer: "Land weicht vom Kunden ab",
    vehicleCountryMismatchTitle: "Fahrzeugland (",
    vehicleCountryMismatchVsCustomer: ") weicht vom Kundenland ab ("
  ,
    taxCodeUiLabel: "Steuernummer",
    vatNumberUiLabel: "USt-IdNr.",
    validSuffix: "gultig",
    optional: "Optional",
    customerEmailLabel: "Kunden-E-Mail",
    vinChassisLabel: "VIN (Fahrgestell)",
    vrnPlateLabel: "Kennzeichen",
    brandLabel: "Marke",
    modelLabel: "Modell",
    confirmDeleteCustomer: "Kunden {name} ({email}) loschen?",
    customerDeletedSuccess: "Kunde geloscht",
    customerDeleteError: "Fehler beim Loschen des Kunden",
    enterValidNumber: "Bitte geben Sie eine gultige Zahl ein",
    viewSignedReadonly: "Daten anzeigen (signiert, nur lesen)",
    editCustomer: "Kunden bearbeiten",
    deleteCustomerOnlyUnsigned: "Kunden loschen (nur wenn nicht signiert)",
    deactivateAction: "Deaktivieren",
    activateAction: "Aktivieren",
    deleteAction: "Loschen",
    salesTeamPlaceholder: "z. B. Vertrieb Nord",
    thisMonth: "Diesen Monat",
    last7days: "Letzte 7 Tage",
    last30daysShort: "Letzte 30 Tage",
    last6MonthsTrend: "Trend der letzten 6 Monate",
    topPerformerOfMonth: "Top Performer des Monats",
    monthHeader: "Monat",
    networkSummary: "Netzwerkubersicht",
    globalMonthlyTarget: "Globales Monatsziel",
  
    mismatchTitle: "Kunden mit zu uberprufendem Land",
    mismatchBodyIntro: "In den letzten 30 Tagen haben Sie",
    mismatchBodyMiddle: "Kunden angelegt, davon haben",
    mismatchBodyEnd: "ein Land, das von der USt-IdNr. oder Telefonvorwahl abweicht. Mit einem Klick korrigieren.",
    mismatchCleanTitle: "Lander-Datenqualitat: ✅ Ausgezeichnete Arbeit",
    mismatchCleanBody: "Alle {n} Kunden der letzten 30 Tage haben ein Land konsistent mit USt-IdNr./Telefon.",
    mismatchCurrent: "Aktuell:",
    mismatchSourceVat: "aus USt-IdNr.",
    mismatchSourcePhone: "aus Telefon",
    mismatchFixBtn: "Korrigieren",
    mismatchConfirmQuestion: "Landerwechsel bestatigen auf",
    mismatchReasonPlaceholder: "Korrekturgrund (optional)",
    mismatchSaving: "Speichern...",
    mismatchConfirmFix: "Korrektur bestatigen",
    mismatchCancel: "Abbrechen",
    mismatchCountryUpdated: "Land aktualisiert:",
    mismatchCorrectionFailed: "Korrekturfehler",
    mismatchCorrectionReasonDefault: "Uber Mismatch-Widget korrigiert (Handler)",
    cannotDeleteContractSigned: "Loschen nicht moglich: Vertrag bereits unterschrieben",
    resendActivationEmail: "Aktivierungs-E-Mail erneut senden",
  
    fpSessionInvalid: "Ungultige Sitzung",
    fpMissingToken: "Zugriffstoken fehlt.",
    fpBackToLogin: "Zuruck zum Login",
    fpPasswordTooShort: "Das neue Passwort muss mindestens 10 Zeichen lang sein.",
    fpPasswordsMismatch: "Passworter stimmen nicht uberein.",
    fpSameAsTemp: "Das neue Passwort darf nicht mit dem temporaren ubereinstimmen.",
    fpSuccess: "Passwort aktualisiert. Bitte melden Sie sich erneut an.",
    fpUpdateFailed: "Passwort konnte nicht aktualisiert werden.",
    fpTitle: "Erstellen Sie Ihr personliches Passwort",
    fpSubtitle: "Bei der ersten Anmeldung mussen Sie das per E-Mail erhaltene temporare Passwort durch ein neues personliches ersetzen.",
    fpTempLabel: "Temporares Passwort (das per E-Mail erhaltene)",
    fpNewLabel: "Neues Passwort (mind. 10 Zeichen)",
    fpConfirmLabel: "Neues Passwort bestatigen",
    fpUpdating: "Aktualisierung…",
    fpSetBtn: "Neues Passwort festlegen",
    fpSecurityNotice: "Aus Sicherheitsgrunden mussen Sie sich am Ende erneut mit dem neuen Passwort anmelden.",
    sellerCreditedLabel: "Zugewiesener Verkaufer",
    sellerCreditedPlaceholder: "Verkaufer auswahlen...",
    sellerCreditedManagerSuffix: "Inhaber",
    sellerCreditedHintNoSellers: "Sie haben noch keine Verkaufer hinzugefugt. Sie konnen diesen Kunden sich selbst zuweisen oder einen Verkaufer im Tab \"Verkaufer\" anlegen.",
    backOfficeUserLabel: "Back-Office-Benutzer (Verwaltungspersonal)",
    backOfficeUserHint: "Back-Office-Benutzer konnen Kunden im Namen der Verkaufer anlegen und alle Vertrage uberwachen, erscheinen aber nicht in der Auswahl \"Zugewiesener Verkaufer\" und haben keine Leistungsstatistiken.",
    createBackOffice: "Back-Office erstellen",
  },
  NL: {
    reset: "Velden wissen", exit: "Afsluiten",
    // Anti-typo double-confirmation fields (Req. Fabrizio 22/02/2026)
    emailConfirmLabel: "Bevestig e-mail (opnieuw invoeren)*",
    emailConfirmPlaceholder: "Voer het e-mailadres opnieuw in",
    emailConfirmOk: "\u2713 E-mails komen overeen",
    emailConfirmMismatch: "\u26A0 E-mails komen niet overeen",
    phoneConfirmLabel: "Bevestig mobiel (opnieuw invoeren)*",
    phoneConfirmPlaceholder: "Voer het telefoonnummer opnieuw in",
    phoneConfirmOk: "\u2713 Telefoonnummers komen overeen",
    phoneConfirmMismatch: "\u26A0 Telefoonnummers komen niet overeen",
    resetConfirm: "Wilt u alle ingevulde velden echt wissen?",
    exitConfirm: "Formulier verlaten? Niet-opgeslagen wijzigingen gaan verloren.",
    dealerFormSubtitle: "De velden worden geleidelijk geactiveerd terwijl u ze invult.",
    creatingCustomerIn: "U maakt een klant aan in",
    changeCountry: "Land wijzigen",
    customerCountry: "Land van de klant",
    recent: "Recent",
    recentCountries: "Recente landen",
    allCountries: "Alle landen",
    confirm: "OK",
    customerType: "Klanttype",
    private: "Particulier",
    business: "Bedrijf",
    privateIdentity: "Persoonlijke gegevens",
    businessIdentity: "Bedrijfsgegevens",
    companyName: "Bedrijfsnaam",
    formatHint: "Formaat",
    vehicleData: "Voertuiggegevens",
    vinSuggestion: "NHTSA-suggestie (VIN)",
    vinNotRecognised: "VIN niet herkend door NHTSA — voer merk en model handmatig in.",
    vinDecodeFailed: "VIN-decoderingsservice tijdelijk niet beschikbaar",
    vinApplied: "Merk en model ingevuld vanuit VIN",
    apply: "Toepassen",
    ignore: "Negeren",
    viesTooltip: "Online verificatie via EU VIES",
    viesFound: "Bedrijfsgegevens gevonden op VIES",
    viesNotFound: "BTW-nummer niet gevonden op VIES",
    viesNotSupported: "VIES alleen beschikbaar voor EU-landen",
    viesUnavailable: "VIES-service tijdelijk niet beschikbaar",
    viesApplied: "VIES-gegevens toegepast op formulier",
    viesError: "VIES-verificatiefout",
    vatRequiredFirst: "Voer eerst het BTW-nummer in",
    completeAllSteps: "Vul alle verplichte velden in om door te gaan",
    vinValidOk: "Geldig VIN (checksum OK)",
    vinValidEU: "Geldig VIN-formaat (EU)",
    vinSuspiciousRun: "Verdacht VIN: te veel identieke opeenvolgende tekens",
    vinChecksumFail: "Ongeldige VIN-checksum: het controlecijfer op positie 9 komt niet overeen",
    vinForbiddenChar: "VIN bevat verboden tekens (I, O, Q)",
    vinBadLength: "VIN moet 17 tekens lang zijn",
    vinVerified: "VIN geverifieerd (NHTSA)",
    vinCheckDigitMismatch: "Controlecijfer komt niet overeen",
    vehicleOriginLabel: "Voertuig",
    differentFromCustomer: "land verschilt van klant",
    vehicleCountryMismatchTitle: "Voertuigland (",
    vehicleCountryMismatchVsCustomer: ") verschilt van klantland ("
  ,
    taxCodeUiLabel: "Belastingnummer",
    vatNumberUiLabel: "BTW-nummer",
    validSuffix: "geldig",
    optional: "Optioneel",
    customerEmailLabel: "E-mail van de klant",
    vinChassisLabel: "VIN (Chassis)",
    vrnPlateLabel: "Kenteken",
    brandLabel: "Merk",
    modelLabel: "Model",
    confirmDeleteCustomer: "Klant {name} ({email}) verwijderen?",
    customerDeletedSuccess: "Klant verwijderd",
    customerDeleteError: "Fout bij verwijderen van klant",
    enterValidNumber: "Voer een geldig nummer in",
    viewSignedReadonly: "Bekijk gegevens (ondertekend, alleen lezen)",
    editCustomer: "Klant bewerken",
    deleteCustomerOnlyUnsigned: "Klant verwijderen (alleen indien niet ondertekend)",
    deactivateAction: "Deactiveren",
    activateAction: "Activeren",
    deleteAction: "Verwijderen",
    salesTeamPlaceholder: "bv. Verkoop Noord",
    thisMonth: "Deze maand",
    last7days: "Laatste 7 dagen",
    last30daysShort: "Laatste 30 dagen",
    last6MonthsTrend: "Trend laatste 6 maanden",
    topPerformerOfMonth: "Top performer van de maand",
    monthHeader: "Maand",
    networkSummary: "Netwerkoverzicht",
    globalMonthlyTarget: "Globaal maanddoel",
  
    mismatchTitle: "Klanten met te controleren land",
    mismatchBodyIntro: "In de laatste 30 dagen heb je",
    mismatchBodyMiddle: "klanten aangemaakt, waarvan",
    mismatchBodyEnd: "een land hebben dat afwijkt van het door BTW of telefoonprefix gesuggereerde. Corrigeer met een klik.",
    mismatchCleanTitle: "Kwaliteit landgegevens: ✅ Goed werk",
    mismatchCleanBody: "Alle {n} klanten van de laatste 30 dagen hebben een land consistent met BTW/telefoon.",
    mismatchCurrent: "Huidig:",
    mismatchSourceVat: "vanuit BTW",
    mismatchSourcePhone: "vanuit telefoon",
    mismatchFixBtn: "Corrigeren",
    mismatchConfirmQuestion: "Bevestig landswijziging naar",
    mismatchReasonPlaceholder: "Reden correctie (optioneel)",
    mismatchSaving: "Opslaan...",
    mismatchConfirmFix: "Correctie bevestigen",
    mismatchCancel: "Annuleren",
    mismatchCountryUpdated: "Land bijgewerkt:",
    mismatchCorrectionFailed: "Correctiefout",
    mismatchCorrectionReasonDefault: "Gecorrigeerd via Mismatch-widget (dealer)",
    cannotDeleteContractSigned: "Verwijderen niet mogelijk: contract al ondertekend",
    resendActivationEmail: "Activerings-e-mail opnieuw verzenden",
  
    fpSessionInvalid: "Ongeldige sessie",
    fpMissingToken: "Toegangstoken ontbreekt.",
    fpBackToLogin: "Terug naar inloggen",
    fpPasswordTooShort: "Het nieuwe wachtwoord moet minimaal 10 tekens lang zijn.",
    fpPasswordsMismatch: "Wachtwoorden komen niet overeen.",
    fpSameAsTemp: "Het nieuwe wachtwoord mag niet hetzelfde zijn als het tijdelijke.",
    fpSuccess: "Wachtwoord bijgewerkt. Log opnieuw in.",
    fpUpdateFailed: "Kan het wachtwoord niet bijwerken.",
    fpTitle: "Maak je persoonlijke wachtwoord aan",
    fpSubtitle: "Bij je eerste login moet je het tijdelijke wachtwoord uit de e-mail vervangen door een nieuw persoonlijk wachtwoord.",
    fpTempLabel: "Tijdelijk wachtwoord (ontvangen per e-mail)",
    fpNewLabel: "Nieuw wachtwoord (min. 10 tekens)",
    fpConfirmLabel: "Bevestig nieuw wachtwoord",
    fpUpdating: "Bijwerken…",
    fpSetBtn: "Nieuw wachtwoord instellen",
    fpSecurityNotice: "Om veiligheidsredenen wordt gevraagd opnieuw in te loggen met het nieuwe wachtwoord.",
    sellerCreditedLabel: "Credited seller",
    sellerCreditedPlaceholder: "Select the seller...",
    sellerCreditedManagerSuffix: "Owner",
    sellerCreditedHintNoSellers: "You have not added any sellers yet. You can credit this customer to yourself or create a seller from the \"Sellers\" tab.",
    backOfficeUserLabel: "Back-Office user (administrative staff)",
    backOfficeUserHint: "Back-Office users can create customers on behalf of sellers and monitor all contracts, but they do not appear in the \"Credited seller\" dropdown and have no performance stats.",
    createBackOffice: "Create Back-Office",
  },
  PT: {
    reset: "Limpar campos", exit: "Sair",
    // Anti-typo double-confirmation fields (Req. Fabrizio 22/02/2026)
    emailConfirmLabel: "Confirmar email (reescreva)*",
    emailConfirmPlaceholder: "Reescreva o endereco de email",
    emailConfirmOk: "\u2713 Os emails correspondem",
    emailConfirmMismatch: "\u26A0 Os emails nao correspondem",
    phoneConfirmLabel: "Confirmar telemovel (reescreva)*",
    phoneConfirmPlaceholder: "Reescreva o numero de telefone",
    phoneConfirmOk: "\u2713 Os numeros correspondem",
    phoneConfirmMismatch: "\u26A0 Os numeros nao correspondem",
    resetConfirm: "Quer mesmo limpar todos os campos preenchidos?",
    exitConfirm: "Sair do formulario? As alteracoes nao guardadas serao perdidas.",
    dealerFormSubtitle: "Os campos sao activados progressivamente a medida que os preenches.",
    creatingCustomerIn: "Estas a criar um cliente em",
    changeCountry: "Mudar pais",
    customerCountry: "Pais do cliente",
    recent: "Recentes",
    recentCountries: "Paises recentes",
    allCountries: "Todos os paises",
    confirm: "OK",
    customerType: "Tipo de Cliente",
    private: "Particular",
    business: "Empresa",
    privateIdentity: "Dados pessoais",
    businessIdentity: "Dados da empresa",
    companyName: "Razao Social",
    formatHint: "Formato",
    vehicleData: "Dados do veiculo",
    vinSuggestion: "Sugestao NHTSA (VIN)",
    vinNotRecognised: "VIN nao reconhecido pela NHTSA — introduza marca e modelo manualmente.",
    vinDecodeFailed: "Servico de descodificacao VIN temporariamente indisponivel",
    vinApplied: "Marca e modelo preenchidos a partir do VIN",
    apply: "Aplicar",
    ignore: "Ignorar",
    viesTooltip: "Verificar online via VIES UE",
    viesFound: "Dados da empresa encontrados no VIES",
    viesNotFound: "Numero de IVA nao encontrado no VIES",
    viesNotSupported: "VIES disponivel apenas para paises da UE",
    viesUnavailable: "Servico VIES temporariamente indisponivel",
    viesApplied: "Dados VIES aplicados ao formulario",
    viesError: "Erro na verificacao VIES",
    vatRequiredFirst: "Introduza primeiro o numero de IVA",
    completeAllSteps: "Preencha todos os campos obrigatorios para continuar",
    vinValidOk: "VIN valido (checksum OK)",
    vinValidEU: "Formato VIN valido (UE)",
    vinSuspiciousRun: "VIN suspeito: demasiados caracteres identicos consecutivos",
    vinChecksumFail: "Checksum VIN invalido: o digito de controlo na posicao 9 nao corresponde",
    vinForbiddenChar: "O VIN contem caracteres nao permitidos (I, O, Q)",
    vinBadLength: "O VIN deve ter 17 caracteres",
    vinVerified: "VIN verificado (NHTSA)",
    vinCheckDigitMismatch: "Digito de controlo nao corresponde",
    vehicleOriginLabel: "Veiculo",
    differentFromCustomer: "pais diferente do cliente",
    vehicleCountryMismatchTitle: "Pais do veiculo (",
    vehicleCountryMismatchVsCustomer: ") diferente do pais do cliente ("
  ,
    taxCodeUiLabel: "Codigo fiscal",
    vatNumberUiLabel: "Numero de IVA",
    validSuffix: "valido",
    optional: "Opcional",
    customerEmailLabel: "E-mail do cliente",
    vinChassisLabel: "VIN (Chassi)",
    vrnPlateLabel: "Matricula",
    brandLabel: "Marca",
    modelLabel: "Modelo",
    confirmDeleteCustomer: "Eliminar o cliente {name} ({email})?",
    customerDeletedSuccess: "Cliente eliminado",
    customerDeleteError: "Erro ao eliminar o cliente",
    enterValidNumber: "Introduza um numero valido",
    viewSignedReadonly: "Ver dados (assinado, somente leitura)",
    editCustomer: "Editar cliente",
    deleteCustomerOnlyUnsigned: "Eliminar cliente (so se nao assinado)",
    deactivateAction: "Desativar",
    activateAction: "Ativar",
    deleteAction: "Eliminar",
    salesTeamPlaceholder: "ex. Vendas Norte",
    thisMonth: "Este mes",
    last7days: "Ultimos 7 dias",
    last30daysShort: "Ultimos 30 dias",
    last6MonthsTrend: "Tendencia dos ultimos 6 meses",
    topPerformerOfMonth: "Top performer do mes",
    monthHeader: "Mes",
    networkSummary: "Resumo da rede",
    globalMonthlyTarget: "Objetivo mensal global",
  
    mismatchTitle: "Clientes com pais a rever",
    mismatchBodyIntro: "Nos ultimos 30 dias criou",
    mismatchBodyMiddle: "clientes, dos quais",
    mismatchBodyEnd: "tem um pais diferente do sugerido por IVA ou prefixo telefonico. Corrija com um clique.",
    mismatchCleanTitle: "Qualidade dados pais: ✅ Excelente trabalho",
    mismatchCleanBody: "Todos os {n} clientes dos ultimos 30 dias tem um pais coerente com IVA/telefone.",
    mismatchCurrent: "Atual:",
    mismatchSourceVat: "de IVA",
    mismatchSourcePhone: "de telefone",
    mismatchFixBtn: "Corrigir",
    mismatchConfirmQuestion: "Confirmar mudanca de pais para",
    mismatchReasonPlaceholder: "Motivo da correcao (opcional)",
    mismatchSaving: "A guardar...",
    mismatchConfirmFix: "Confirmar correcao",
    mismatchCancel: "Cancelar",
    mismatchCountryUpdated: "Pais atualizado:",
    mismatchCorrectionFailed: "Erro de correcao",
    mismatchCorrectionReasonDefault: "Corrigido via widget Mismatch (revendedor)",
    cannotDeleteContractSigned: "Nao e possivel eliminar: contrato ja assinado",
    resendActivationEmail: "Reenviar e-mail de ativacao",
  
    fpSessionInvalid: "Sessao invalida",
    fpMissingToken: "Token de acesso em falta.",
    fpBackToLogin: "Voltar ao login",
    fpPasswordTooShort: "A nova palavra-passe deve ter pelo menos 10 caracteres.",
    fpPasswordsMismatch: "As palavras-passe nao coincidem.",
    fpSameAsTemp: "A nova palavra-passe nao pode coincidir com a temporaria.",
    fpSuccess: "Palavra-passe atualizada. Inicie sessao novamente.",
    fpUpdateFailed: "Nao foi possivel atualizar a palavra-passe.",
    fpTitle: "Crie a sua palavra-passe pessoal",
    fpSubtitle: "No primeiro acesso deve substituir a palavra-passe temporaria recebida por email por uma nova palavra-passe pessoal.",
    fpTempLabel: "Palavra-passe temporaria (a recebida por email)",
    fpNewLabel: "Nova palavra-passe (min. 10 caracteres)",
    fpConfirmLabel: "Confirme a nova palavra-passe",
    fpUpdating: "A atualizar…",
    fpSetBtn: "Definir nova palavra-passe",
    fpSecurityNotice: "Por razoes de seguranca, sera necessario iniciar sessao novamente com a nova palavra-passe.",
    sellerCreditedLabel: "Credited seller",
    sellerCreditedPlaceholder: "Select the seller...",
    sellerCreditedManagerSuffix: "Owner",
    sellerCreditedHintNoSellers: "You have not added any sellers yet. You can credit this customer to yourself or create a seller from the \"Sellers\" tab.",
    backOfficeUserLabel: "Back-Office user (administrative staff)",
    backOfficeUserHint: "Back-Office users can create customers on behalf of sellers and monitor all contracts, but they do not appear in the \"Credited seller\" dropdown and have no performance stats.",
    createBackOffice: "Create Back-Office",
  },
  PL: {
    reset: "Wyczysc pola", exit: "Wyjdz",
    // Anti-typo double-confirmation fields (Req. Fabrizio 22/02/2026)
    emailConfirmLabel: "Potwierdz email (wpisz ponownie)*",
    emailConfirmPlaceholder: "Wpisz ponownie adres email",
    emailConfirmOk: "\u2713 Adresy email sa zgodne",
    emailConfirmMismatch: "\u26A0 Adresy email nie sa zgodne",
    phoneConfirmLabel: "Potwierdz komorke (wpisz ponownie)*",
    phoneConfirmPlaceholder: "Wpisz ponownie numer telefonu",
    phoneConfirmOk: "\u2713 Numery telefonu sa zgodne",
    phoneConfirmMismatch: "\u26A0 Numery telefonu nie sa zgodne",
    resetConfirm: "Czy na pewno chcesz wyczyscic wszystkie wypelnione pola?",
    exitConfirm: "Opuscic formularz? Niezapisane zmiany zostana utracone.",
    dealerFormSubtitle: "Pola aktywuja sie kolejno w miare ich wypelniania.",
    creatingCustomerIn: "Tworzysz klienta w",
    changeCountry: "Zmien kraj",
    customerCountry: "Kraj klienta",
    recent: "Ostatnie",
    recentCountries: "Ostatnie kraje",
    allCountries: "Wszystkie kraje",
    confirm: "OK",
    customerType: "Typ klienta",
    private: "Osoba prywatna",
    business: "Firma",
    privateIdentity: "Dane osobowe",
    businessIdentity: "Dane firmy",
    companyName: "Nazwa firmy",
    formatHint: "Format",
    vehicleData: "Dane pojazdu",
    vinSuggestion: "Sugestia NHTSA (VIN)",
    vinNotRecognised: "VIN nierozpoznany przez NHTSA — wprowadz marke i model recznie.",
    vinDecodeFailed: "Usluga dekodowania VIN tymczasowo niedostepna",
    vinApplied: "Marka i model uzupelnione z VIN",
    apply: "Zastosuj",
    ignore: "Ignoruj",
    viesTooltip: "Weryfikacja online przez VIES UE",
    viesFound: "Dane firmy znalezione w VIES",
    viesNotFound: "Numer VAT nie znaleziony w VIES",
    viesNotSupported: "VIES dostepny tylko dla krajow UE",
    viesUnavailable: "Usluga VIES tymczasowo niedostepna",
    viesApplied: "Dane VIES zastosowane do formularza",
    viesError: "Błąd weryfikacji VIES",
    vatRequiredFirst: "Najpierw podaj numer NIP",
    vatCountryMismatchTitle: "Wykryto NIP z innego kraju",
    vatCountryMismatchBody: "Prefiks NIP wskazuje na klienta z {detected}, ale obecnie kraj klienta to {current}. Czy chcesz go zaktualizować?",
    vatCountrySwitchTo: "Ustaw kraj na {detected}",
    vatCountrySwitchedTo: "Kraj klienta zaktualizowany:",
    phoneCountryMismatchTitle: "Wykryto numer telefonu z innego kraju",
    phoneCountryMismatchBody: "Prefiks telefonu wskazuje na klienta z {detected}, ale obecnie kraj klienta to {current}. Czy chcesz go zaktualizować?",
    phoneCountrySwitchTo: "Ustaw kraj na {detected}",
    phoneCountrySwitchedTo: "Kraj klienta zaktualizowany:",
    completeAllSteps: "Wypelnij wszystkie wymagane pola, aby kontynuowac",
    vinValidOk: "Prawidlowy VIN (suma kontrolna OK)",
    vinValidEU: "Prawidlowy format VIN (UE)",
    vinSuspiciousRun: "Podejrzany VIN: zbyt wiele identycznych kolejnych znakow",
    vinChecksumFail: "Nieprawidlowa suma kontrolna VIN: cyfra kontrolna w pozycji 9 nie zgadza sie",
    vinForbiddenChar: "VIN zawiera niedozwolone znaki (I, O, Q)",
    vinBadLength: "VIN musi miec 17 znakow",
    vinVerified: "VIN zweryfikowany (NHTSA)",
    vinCheckDigitMismatch: "Cyfra kontrolna nie zgadza sie",
    vehicleOriginLabel: "Pojazd",
    differentFromCustomer: "kraj rozni sie od klienta",
    vehicleCountryMismatchTitle: "Kraj pojazdu (",
    vehicleCountryMismatchVsCustomer: ") rozni sie od kraju klienta ("
  ,
    taxCodeUiLabel: "Numer podatkowy",
    vatNumberUiLabel: "Numer VAT",
    validSuffix: "prawidlowy",
    optional: "Opcjonalne",
    customerEmailLabel: "Email klienta",
    vinChassisLabel: "VIN (Nadwozie)",
    vrnPlateLabel: "Numer rejestracyjny",
    brandLabel: "Marka",
    modelLabel: "Model",
    confirmDeleteCustomer: "Usunac klienta {name} ({email})?",
    customerDeletedSuccess: "Klient usuniety",
    customerDeleteError: "Blad usuwania klienta",
    enterValidNumber: "Wpisz prawidlowy numer",
    viewSignedReadonly: "Zobacz dane (podpisane, tylko do odczytu)",
    editCustomer: "Edytuj klienta",
    deleteCustomerOnlyUnsigned: "Usun klienta (tylko jesli nie podpisany)",
    deactivateAction: "Dezaktywuj",
    activateAction: "Aktywuj",
    deleteAction: "Usun",
    salesTeamPlaceholder: "np. Sprzedaz Polnoc",
    thisMonth: "W tym miesiacu",
    last7days: "Ostatnie 7 dni",
    last30daysShort: "Ostatnie 30 dni",
    last6MonthsTrend: "Trend ostatnich 6 miesiecy",
    topPerformerOfMonth: "Top wykonawca miesiaca",
    monthHeader: "Miesiac",
    networkSummary: "Podsumowanie sieci",
    globalMonthlyTarget: "Globalny cel miesieczny",
  
    mismatchTitle: "Klienci z krajem do sprawdzenia",
    mismatchBodyIntro: "W ciagu ostatnich 30 dni utworzyles",
    mismatchBodyMiddle: "klientow, z czego",
    mismatchBodyEnd: "ma kraj rozny od sugerowanego przez VAT lub prefiks telefonu. Popraw jednym klikniciem.",
    mismatchCleanTitle: "Jakosc danych kraju: ✅ Swietna robota",
    mismatchCleanBody: "Wszyscy {n} klienci z ostatnich 30 dni maja kraj zgodny z VAT/telefonem.",
    mismatchCurrent: "Obecny:",
    mismatchSourceVat: "z VAT",
    mismatchSourcePhone: "z telefonu",
    mismatchFixBtn: "Popraw",
    mismatchConfirmQuestion: "Potwierdz zmiane kraju na",
    mismatchReasonPlaceholder: "Powod korekty (opcjonalnie)",
    mismatchSaving: "Zapisywanie...",
    mismatchConfirmFix: "Potwierdz korekte",
    mismatchCancel: "Anuluj",
    mismatchCountryUpdated: "Kraj zaktualizowany:",
    mismatchCorrectionFailed: "Blad korekty",
    mismatchCorrectionReasonDefault: "Poprawione przez widget Mismatch (dealer)",
    cannotDeleteContractSigned: "Nie mozna usunac: umowa juz podpisana",
    resendActivationEmail: "Wyslij ponownie email aktywacyjny",
  
    fpSessionInvalid: "Nieprawidlowa sesja",
    fpMissingToken: "Brakuje tokenu dostepu.",
    fpBackToLogin: "Powrot do logowania",
    fpPasswordTooShort: "Nowe haslo musi miec co najmniej 10 znakow.",
    fpPasswordsMismatch: "Hasla nie pasuja do siebie.",
    fpSameAsTemp: "Nowe haslo nie moze byc takie samo jak tymczasowe.",
    fpSuccess: "Haslo zaktualizowane. Zaloguj sie ponownie.",
    fpUpdateFailed: "Nie mozna zaktualizowac hasla.",
    fpTitle: "Utworz swoje osobiste haslo",
    fpSubtitle: "Przy pierwszym logowaniu musisz zastapic tymczasowe haslo otrzymane mailem nowym haslem osobistym.",
    fpTempLabel: "Haslo tymczasowe (otrzymane mailem)",
    fpNewLabel: "Nowe haslo (min. 10 znakow)",
    fpConfirmLabel: "Potwierdz nowe haslo",
    fpUpdating: "Aktualizowanie…",
    fpSetBtn: "Ustaw nowe haslo",
    fpSecurityNotice: "Ze wzgledow bezpieczenstwa po zakonczeniu zostaniesz poproszony o ponowne zalogowanie sie nowym haslem.",
    sellerCreditedLabel: "Przypisany sprzedawca",
    sellerCreditedPlaceholder: "Wybierz sprzedawce...",
    sellerCreditedManagerSuffix: "Wlasciciel",
    sellerCreditedHintNoSellers: "Nie dodano jeszcze sprzedawcow. Mozesz przypisac tego klienta do siebie lub utworzyc sprzedawce z karty \"Sprzedawcy\".",
    backOfficeUserLabel: "Uzytkownik Back-Office (personel administracyjny)",
    backOfficeUserHint: "Uzytkownik Back-Office moze dodawac klientow w imieniu sprzedawcow i monitorowac wszystkie umowy, ale nie pojawia sie w polu \"Przypisany sprzedawca\" i nie ma statystyk wydajnosci.",
    createBackOffice: "Utworz Back-Office",
  },
  SE: {
    reset: "Rensa falt", exit: "Avsluta",
    // Anti-typo double-confirmation fields (Req. Fabrizio 22/02/2026)
    emailConfirmLabel: "Bekrafta e-post (skriv igen)*",
    emailConfirmPlaceholder: "Skriv e-postadressen igen",
    emailConfirmOk: "\u2713 E-postadresserna matchar",
    emailConfirmMismatch: "\u26A0 E-postadresserna matchar inte",
    phoneConfirmLabel: "Bekrafta mobil (skriv igen)*",
    phoneConfirmPlaceholder: "Skriv telefonnumret igen",
    phoneConfirmOk: "\u2713 Telefonnumren matchar",
    phoneConfirmMismatch: "\u26A0 Telefonnumren matchar inte",
    resetConfirm: "Vill du verkligen rensa alla ifyllda falt?",
    exitConfirm: "Avsluta formularet? Osparade andringar gar forlorade.",
    dealerFormSubtitle: "Falten aktiveras stegvis nar du fyller i dem.",
    creatingCustomerIn: "Du skapar en kund i",
    changeCountry: "Andra land",
    customerCountry: "Kundens land",
    recent: "Senaste",
    recentCountries: "Senaste landerna",
    allCountries: "Alla lander",
    confirm: "OK",
    customerType: "Kundtyp",
    private: "Privatperson",
    business: "Foretag",
    privateIdentity: "Personuppgifter",
    businessIdentity: "Foretagsuppgifter",
    companyName: "Foretagsnamn",
    formatHint: "Format",
    vehicleData: "Fordonsdata",
    vinSuggestion: "NHTSA-forslag (VIN)",
    vinNotRecognised: "VIN inte igenkant av NHTSA — ange marke och modell manuellt.",
    vinDecodeFailed: "VIN-avkodningstjansten tillfalligt otillganglig",
    vinApplied: "Marke och modell hamtade fran VIN",
    apply: "Tillampa",
    ignore: "Ignorera",
    viesTooltip: "Verifiera online via EU VIES",
    viesFound: "Foretagsdata hittade i VIES",
    viesNotFound: "Momsnummer hittades inte i VIES",
    viesNotSupported: "VIES tillgangligt endast for EU-lander",
    viesUnavailable: "VIES-tjansten tillfalligt otillganglig",
    viesApplied: "VIES-data tillampade pa formularet",
    viesError: "VIES-verifieringsfel",
    vatRequiredFirst: "Ange momsnummer forst",
    completeAllSteps: "Fyll i alla obligatoriska falt for att fortsatta",
    vinValidOk: "Giltigt VIN (kontrollsumma OK)",
    vinValidEU: "Giltigt VIN-format (EU)",
    vinSuspiciousRun: "Misstankt VIN: for manga identiska tecken i rad",
    vinChecksumFail: "Ogiltig VIN-kontrollsumma: kontrollsiffran i position 9 stammer inte",
    vinForbiddenChar: "VIN innehaller forbjudna tecken (I, O, Q)",
    vinBadLength: "VIN maste vara 17 tecken langt",
    vinVerified: "VIN verifierat (NHTSA)",
    vinCheckDigitMismatch: "Kontrollsiffran stammer inte",
    vehicleOriginLabel: "Fordon",
    differentFromCustomer: "land skiljer sig fran kund",
    vehicleCountryMismatchTitle: "Fordonsland (",
    vehicleCountryMismatchVsCustomer: ") skiljer sig fran kundens land ("
  ,
    taxCodeUiLabel: "Skattenummer",
    vatNumberUiLabel: "Momsnummer",
    validSuffix: "giltigt",
    optional: "Valfritt",
    customerEmailLabel: "Kund e-post",
    vinChassisLabel: "VIN (Chassi)",
    vrnPlateLabel: "Registreringsnummer",
    brandLabel: "Marke",
    modelLabel: "Modell",
    confirmDeleteCustomer: "Ta bort kund {name} ({email})?",
    customerDeletedSuccess: "Kund borttagen",
    customerDeleteError: "Fel vid borttagning av kund",
    enterValidNumber: "Ange ett giltigt nummer",
    viewSignedReadonly: "Visa data (signerat, skrivskyddat)",
    editCustomer: "Redigera kund",
    deleteCustomerOnlyUnsigned: "Ta bort kund (endast om inte signerat)",
    deactivateAction: "Inaktivera",
    activateAction: "Aktivera",
    deleteAction: "Ta bort",
    salesTeamPlaceholder: "t.ex. Forsaljning Norr",
    thisMonth: "Denna manad",
    last7days: "Senaste 7 dagarna",
    last30daysShort: "Senaste 30 dagarna",
    last6MonthsTrend: "Trend senaste 6 manaderna",
    topPerformerOfMonth: "Manadens basta presterare",
    monthHeader: "Manad",
    networkSummary: "Natverksoversikt",
    globalMonthlyTarget: "Globalt manatligt mal",
  
    mismatchTitle: "Kunder med land att granska",
    mismatchBodyIntro: "De senaste 30 dagarna har du skapat",
    mismatchBodyMiddle: "kunder, varav",
    mismatchBodyEnd: "har ett land som skiljer sig fran det som foreslas av moms eller telefonprefix. Korrigera med ett klick.",
    mismatchCleanTitle: "Kvalitet landsdata: ✅ Bra jobbat",
    mismatchCleanBody: "Alla {n} kunder fran de senaste 30 dagarna har ett land som ar konsistent med moms/telefon.",
    mismatchCurrent: "Nuvarande:",
    mismatchSourceVat: "fran moms",
    mismatchSourcePhone: "fran telefon",
    mismatchFixBtn: "Korrigera",
    mismatchConfirmQuestion: "Bekrafta landsbyte till",
    mismatchReasonPlaceholder: "Orsak till korrigering (valfritt)",
    mismatchSaving: "Sparar...",
    mismatchConfirmFix: "Bekrafta korrigering",
    mismatchCancel: "Avbryt",
    mismatchCountryUpdated: "Land uppdaterat:",
    mismatchCorrectionFailed: "Korrigeringsfel",
    mismatchCorrectionReasonDefault: "Korrigerat via Mismatch-widget (aterforsaljare)",
    cannotDeleteContractSigned: "Kan inte ta bort: avtal redan undertecknat",
    resendActivationEmail: "Skicka aktiveringsmail igen",
  
    fpSessionInvalid: "Ogiltig session",
    fpMissingToken: "Atkomsttoken saknas.",
    fpBackToLogin: "Tillbaka till inloggning",
    fpPasswordTooShort: "Det nya losenordet maste vara minst 10 tecken langt.",
    fpPasswordsMismatch: "Losenorden matchar inte.",
    fpSameAsTemp: "Det nya losenordet kan inte matcha det temporara.",
    fpSuccess: "Losenord uppdaterat. Logga in igen.",
    fpUpdateFailed: "Det gick inte att uppdatera losenordet.",
    fpTitle: "Skapa ditt personliga losenord",
    fpSubtitle: "Vid din forsta inloggning maste du ersatta det temporara losenordet du fick via e-post med ett nytt personligt.",
    fpTempLabel: "Temporart losenord (det du fick via e-post)",
    fpNewLabel: "Nytt losenord (min. 10 tecken)",
    fpConfirmLabel: "Bekrafta nytt losenord",
    fpUpdating: "Uppdaterar…",
    fpSetBtn: "Stall in nytt losenord",
    fpSecurityNotice: "Av sakerhetsskal kommer du att uppmanas att logga in igen med det nya losenordet.",
    sellerCreditedLabel: "Credited seller",
    sellerCreditedPlaceholder: "Select the seller...",
    sellerCreditedManagerSuffix: "Owner",
    sellerCreditedHintNoSellers: "You have not added any sellers yet. You can credit this customer to yourself or create a seller from the \"Sellers\" tab.",
    backOfficeUserLabel: "Back-Office user (administrative staff)",
    backOfficeUserHint: "Back-Office users can create customers on behalf of sellers and monitor all contracts, but they do not appear in the \"Credited seller\" dropdown and have no performance stats.",
    createBackOffice: "Create Back-Office",
  },
  NO: {
    reset: "Tom felter", exit: "Avslutt",
    // Anti-typo double-confirmation fields (Req. Fabrizio 22/02/2026)
    emailConfirmLabel: "Bekreft e-post (skriv inn pa nytt)*",
    emailConfirmPlaceholder: "Skriv e-postadressen pa nytt",
    emailConfirmOk: "\u2713 E-postadressene samsvarer",
    emailConfirmMismatch: "\u26A0 E-postadressene samsvarer ikke",
    phoneConfirmLabel: "Bekreft mobil (skriv inn pa nytt)*",
    phoneConfirmPlaceholder: "Skriv telefonnummeret pa nytt",
    phoneConfirmOk: "\u2713 Telefonnumrene samsvarer",
    phoneConfirmMismatch: "\u26A0 Telefonnumrene samsvarer ikke",
    resetConfirm: "Vil du virkelig tomme alle utfylte felt?",
    exitConfirm: "Avslutte skjemaet? Endringer som ikke er lagret vil ga tapt.",
    dealerFormSubtitle: "Feltene aktiveres gradvis etter hvert som du fyller dem ut.",
    creatingCustomerIn: "Du oppretter en kunde i",
    changeCountry: "Endre land",
    customerCountry: "Kundens land",
    recent: "Nylige",
    recentCountries: "Nylige land",
    allCountries: "Alle land",
    confirm: "OK",
    customerType: "Kundetype",
    private: "Privatperson",
    business: "Bedrift",
    privateIdentity: "Personopplysninger",
    businessIdentity: "Bedriftsopplysninger",
    companyName: "Firmanavn",
    formatHint: "Format",
    vehicleData: "Kjoretoydata",
    vinSuggestion: "NHTSA-forslag (VIN)",
    vinNotRecognised: "VIN ikke gjenkjent av NHTSA — vennligst angi merke og modell manuelt.",
    vinDecodeFailed: "VIN-dekodingstjenesten midlertidig utilgjengelig",
    vinApplied: "Merke og modell hentet fra VIN",
    apply: "Bruk",
    ignore: "Ignorer",
    viesTooltip: "Online verifisering via EU VIES",
    viesFound: "Bedriftsdata funnet i VIES",
    viesNotFound: "MVA-nummer ikke funnet i VIES",
    viesNotSupported: "VIES tilgjengelig kun for EU-land",
    viesUnavailable: "VIES-tjenesten midlertidig utilgjengelig",
    viesApplied: "VIES-data brukt i skjemaet",
    viesError: "VIES-verifiseringsfeil",
    vatRequiredFirst: "Vennligst angi MVA-nummer forst",
    completeAllSteps: "Fyll ut alle obligatoriske felt for a fortsette",
    vinValidOk: "Gyldig VIN (kontrollsum OK)",
    vinValidEU: "Gyldig VIN-format (EU)",
    vinSuspiciousRun: "Mistenkelig VIN: for mange identiske tegn pa rad",
    vinChecksumFail: "Ugyldig VIN-kontrollsum: kontrollsiffer i posisjon 9 stemmer ikke",
    vinForbiddenChar: "VIN inneholder ugyldige tegn (I, O, Q)",
    vinBadLength: "VIN ma vaere 17 tegn lang",
    vinVerified: "VIN verifisert (NHTSA)",
    vinCheckDigitMismatch: "Kontrollsiffer stemmer ikke",
    vehicleOriginLabel: "Kjoretoy",
    differentFromCustomer: "land avviker fra kunde",
    vehicleCountryMismatchTitle: "Kjoretoyets land (",
    vehicleCountryMismatchVsCustomer: ") avviker fra kundens land ("
  ,
    taxCodeUiLabel: "Skattenummer",
    vatNumberUiLabel: "MVA-nummer",
    validSuffix: "gyldig",
    optional: "Valgfritt",
    customerEmailLabel: "Kundens e-post",
    vinChassisLabel: "VIN (Chassis)",
    vrnPlateLabel: "Registreringsnummer",
    brandLabel: "Merke",
    modelLabel: "Modell",
    confirmDeleteCustomer: "Slette kunde {name} ({email})?",
    customerDeletedSuccess: "Kunde slettet",
    customerDeleteError: "Feil ved sletting av kunde",
    enterValidNumber: "Vennligst angi et gyldig nummer",
    viewSignedReadonly: "Vis data (signert, skrivebeskyttet)",
    editCustomer: "Rediger kunde",
    deleteCustomerOnlyUnsigned: "Slett kunde (kun hvis ikke signert)",
    deactivateAction: "Deaktiver",
    activateAction: "Aktiver",
    deleteAction: "Slett",
    salesTeamPlaceholder: "f.eks. Salg Nord",
    thisMonth: "Denne maneden",
    last7days: "Siste 7 dager",
    last30daysShort: "Siste 30 dager",
    last6MonthsTrend: "Trend siste 6 maneder",
    topPerformerOfMonth: "Manedens beste",
    monthHeader: "Maned",
    networkSummary: "Nettverksoversikt",
    globalMonthlyTarget: "Globalt manedlig mal",
  
    mismatchTitle: "Kunder med land som ma sjekkes",
    mismatchBodyIntro: "I de siste 30 dagene har du opprettet",
    mismatchBodyMiddle: "kunder, hvorav",
    mismatchBodyEnd: "har et land som er forskjellig fra det som foreslas av MVA eller telefonprefiks. Korriger med et klikk.",
    mismatchCleanTitle: "Kvalitet landsdata: ✅ Bra jobba",
    mismatchCleanBody: "Alle {n} kundene fra de siste 30 dagene har et land konsistent med MVA/telefon.",
    mismatchCurrent: "Nahveerende:",
    mismatchSourceVat: "fra MVA",
    mismatchSourcePhone: "fra telefon",
    mismatchFixBtn: "Korriger",
    mismatchConfirmQuestion: "Bekreft landsskifte til",
    mismatchReasonPlaceholder: "Korrigeringsgrunn (valgfritt)",
    mismatchSaving: "Lagrer...",
    mismatchConfirmFix: "Bekreft korrigering",
    mismatchCancel: "Avbryt",
    mismatchCountryUpdated: "Land oppdatert:",
    mismatchCorrectionFailed: "Korrigeringsfeil",
    mismatchCorrectionReasonDefault: "Korrigert via Mismatch-widget (forhandler)",
    cannotDeleteContractSigned: "Kan ikke slette: kontrakt allerede signert",
    resendActivationEmail: "Send aktiveringsmail pa nytt",
  
    fpSessionInvalid: "Ugyldig okt",
    fpMissingToken: "Tilgangstoken mangler.",
    fpBackToLogin: "Tilbake til innlogging",
    fpPasswordTooShort: "Det nye passordet ma vare pa minst 10 tegn.",
    fpPasswordsMismatch: "Passordene samsvarer ikke.",
    fpSameAsTemp: "Det nye passordet kan ikke vare det samme som det midlertidige.",
    fpSuccess: "Passord oppdatert. Logg inn pa nytt.",
    fpUpdateFailed: "Kunne ikke oppdatere passord.",
    fpTitle: "Lag ditt personlige passord",
    fpSubtitle: "Ved forstegangsinnlogging ma du erstatte det midlertidige passordet du fikk via e-post med et nytt personlig.",
    fpTempLabel: "Midlertidig passord (det du fikk via e-post)",
    fpNewLabel: "Nytt passord (min. 10 tegn)",
    fpConfirmLabel: "Bekreft nytt passord",
    fpUpdating: "Oppdaterer…",
    fpSetBtn: "Sett nytt passord",
    fpSecurityNotice: "Av sikkerhetshensyn vil du bli bedt om a logge inn pa nytt med det nye passordet.",
    sellerCreditedLabel: "Credited seller",
    sellerCreditedPlaceholder: "Select the seller...",
    sellerCreditedManagerSuffix: "Owner",
    sellerCreditedHintNoSellers: "You have not added any sellers yet. You can credit this customer to yourself or create a seller from the \"Sellers\" tab.",
    backOfficeUserLabel: "Back-Office user (administrative staff)",
    backOfficeUserHint: "Back-Office users can create customers on behalf of sellers and monitor all contracts, but they do not appear in the \"Credited seller\" dropdown and have no performance stats.",
    createBackOffice: "Create Back-Office",
  },
  FI: {
    reset: "Tyhjenna kentat", exit: "Poistu",
    // Anti-typo double-confirmation fields (Req. Fabrizio 22/02/2026)
    emailConfirmLabel: "Vahvista sahkoposti (kirjoita uudelleen)*",
    emailConfirmPlaceholder: "Kirjoita sahkopostiosoite uudelleen",
    emailConfirmOk: "\u2713 Sahkopostiosoitteet tasmaavat",
    emailConfirmMismatch: "\u26A0 Sahkopostiosoitteet eivat tasmaa",
    phoneConfirmLabel: "Vahvista puhelin (kirjoita uudelleen)*",
    phoneConfirmPlaceholder: "Kirjoita puhelinnumero uudelleen",
    phoneConfirmOk: "\u2713 Puhelinnumerot tasmaavat",
    phoneConfirmMismatch: "\u26A0 Puhelinnumerot eivat tasmaa",
    resetConfirm: "Haluatko todella tyhjentaa kaikki taytetyt kentat?",
    exitConfirm: "Poistutko lomakkeesta? Tallentamattomat muutokset menetetaan.",
    dealerFormSubtitle: "Kentat aktivoituvat asteittain sita mukaa kun taytat ne.",
    creatingCustomerIn: "Olet luomassa asiakasta maassa",
    changeCountry: "Vaihda maa",
    customerCountry: "Asiakkaan maa",
    recent: "Viimeisimmat",
    recentCountries: "Viimeisimmat maat",
    allCountries: "Kaikki maat",
    confirm: "OK",
    customerType: "Asiakastyyppi",
    private: "Yksityishenkilo",
    business: "Yritys",
    privateIdentity: "Henkilotiedot",
    businessIdentity: "Yritystiedot",
    companyName: "Yrityksen nimi",
    formatHint: "Muoto",
    vehicleData: "Ajoneuvon tiedot",
    vinSuggestion: "NHTSA-ehdotus (VIN)",
    vinNotRecognised: "NHTSA ei tunnistanut VIN-numeroa — anna merkki ja malli manuaalisesti.",
    vinDecodeFailed: "VIN-dekoodauspalvelu tilapaisesti pois kaytosta",
    vinApplied: "Merkki ja malli taytetty VIN-numerosta",
    apply: "Kayta",
    ignore: "Ohita",
    viesTooltip: "Online-vahvistus EU VIES -palvelussa",
    viesFound: "Yritystiedot loytyivat VIES-palvelusta",
    viesNotFound: "ALV-numeroa ei loytynyt VIES-palvelusta",
    viesNotSupported: "VIES kaytettavissa vain EU-maissa",
    viesUnavailable: "VIES-palvelu tilapaisesti pois kaytosta",
    viesApplied: "VIES-tiedot lisatty lomakkeelle",
    viesError: "VIES-vahvistusvirhe",
    vatRequiredFirst: "Anna ensin ALV-numero",
    completeAllSteps: "Tayta kaikki vaaditut kentat jatkaaksesi",
    vinValidOk: "Kelvollinen VIN (tarkistussumma OK)",
    vinValidEU: "Kelvollinen VIN-muoto (EU)",
    vinSuspiciousRun: "Epailyttava VIN: liian monta identtista perakkaista merkkia",
    vinChecksumFail: "Virheellinen VIN-tarkistussumma: tarkistusnumero asemassa 9 ei tasmaa",
    vinForbiddenChar: "VIN sisaltaa kiellettyja merkkeja (I, O, Q)",
    vinBadLength: "VIN-numeron on oltava 17 merkkia pitka",
    vinVerified: "VIN vahvistettu (NHTSA)",
    vinCheckDigitMismatch: "Tarkistusnumero ei tasmaa",
    vehicleOriginLabel: "Ajoneuvo",
    differentFromCustomer: "maa eroaa asiakkaasta",
    vehicleCountryMismatchTitle: "Ajoneuvon maa (",
    vehicleCountryMismatchVsCustomer: ") eroaa asiakkaan maasta ("
  ,
    taxCodeUiLabel: "Verotunnus",
    vatNumberUiLabel: "ALV-numero",
    validSuffix: "kelvollinen",
    optional: "Valinnainen",
    customerEmailLabel: "Asiakkaan sahkoposti",
    vinChassisLabel: "VIN (Runko)",
    vrnPlateLabel: "Rekisterinumero",
    brandLabel: "Merkki",
    modelLabel: "Malli",
    confirmDeleteCustomer: "Poistetaanko asiakas {name} ({email})?",
    customerDeletedSuccess: "Asiakas poistettu",
    customerDeleteError: "Virhe asiakkaan poistossa",
    enterValidNumber: "Anna kelvollinen numero",
    viewSignedReadonly: "Nayta tiedot (allekirjoitettu, vain luku)",
    editCustomer: "Muokkaa asiakasta",
    deleteCustomerOnlyUnsigned: "Poista asiakas (vain jos allekirjoittamaton)",
    deactivateAction: "Poista kaytosta",
    activateAction: "Ota kayttoon",
    deleteAction: "Poista",
    salesTeamPlaceholder: "esim. Myynti Pohjoinen",
    thisMonth: "Tassa kuussa",
    last7days: "Viimeiset 7 paivaa",
    last30daysShort: "Viimeiset 30 paivaa",
    last6MonthsTrend: "Viimeisten 6 kuukauden trendi",
    topPerformerOfMonth: "Kuukauden parhaiten suoriutuva",
    monthHeader: "Kuukausi",
    networkSummary: "Verkostoyhteenveto",
    globalMonthlyTarget: "Globaali kuukausitavoite",
  
    mismatchTitle: "Asiakkaat joilla on tarkistettava maa",
    mismatchBodyIntro: "Viimeisten 30 paivan aikana olet luonut",
    mismatchBodyMiddle: "asiakasta, joista",
    mismatchBodyEnd: "on maa, joka eroaa ALV:n tai puhelinetuliitten ehdottamasta. Korjaa yhdella klikkauksella.",
    mismatchCleanTitle: "Maatietojen laatu: ✅ Hyvaa tyota",
    mismatchCleanBody: "Kaikki {n} asiakasta viimeisten 30 paivan aikana ovat maakohtaisesti yhdenmukaisia ALV/puhelimen kanssa.",
    mismatchCurrent: "Nykyinen:",
    mismatchSourceVat: "ALV:sta",
    mismatchSourcePhone: "puhelimesta",
    mismatchFixBtn: "Korjaa",
    mismatchConfirmQuestion: "Vahvista maan vaihto",
    mismatchReasonPlaceholder: "Korjauksen syy (valinnainen)",
    mismatchSaving: "Tallennetaan...",
    mismatchConfirmFix: "Vahvista korjaus",
    mismatchCancel: "Peruuta",
    mismatchCountryUpdated: "Maa paivitetty:",
    mismatchCorrectionFailed: "Korjausvirhe",
    mismatchCorrectionReasonDefault: "Korjattu Mismatch-widgetilla (jalleenmyyja)",
    cannotDeleteContractSigned: "Ei voida poistaa: sopimus jo allekirjoitettu",
    resendActivationEmail: "Lahetä aktivointisahkoposti uudelleen",
  
    fpSessionInvalid: "Virheellinen istunto",
    fpMissingToken: "Pasytoken puuttuu.",
    fpBackToLogin: "Takaisin kirjautumiseen",
    fpPasswordTooShort: "Uuden salasanan tulee olla vahintaan 10 merkkia pitka.",
    fpPasswordsMismatch: "Salasanat eivat tasmaa.",
    fpSameAsTemp: "Uusi salasana ei voi olla sama kuin valiaikainen.",
    fpSuccess: "Salasana paivitetty. Kirjaudu uudelleen.",
    fpUpdateFailed: "Salasanaa ei voitu paivittaa.",
    fpTitle: "Luo henkilokohtainen salasanasi",
    fpSubtitle: "Ensimmaisella kirjautumiskerralla sinun on korvattava sahkopostitse saatu valiaikainen salasana uudella henkilokohtaisella.",
    fpTempLabel: "Valiaikainen salasana (sahkopostilla saatu)",
    fpNewLabel: "Uusi salasana (vah. 10 merkkia)",
    fpConfirmLabel: "Vahvista uusi salasana",
    fpUpdating: "Paivitetaan…",
    fpSetBtn: "Aseta uusi salasana",
    fpSecurityNotice: "Turvallisuussyista sinua pyydetaan kirjautumaan uudelleen uudella salasanalla.",
    sellerCreditedLabel: "Credited seller",
    sellerCreditedPlaceholder: "Select the seller...",
    sellerCreditedManagerSuffix: "Owner",
    sellerCreditedHintNoSellers: "You have not added any sellers yet. You can credit this customer to yourself or create a seller from the \"Sellers\" tab.",
    backOfficeUserLabel: "Back-Office user (administrative staff)",
    backOfficeUserHint: "Back-Office users can create customers on behalf of sellers and monitor all contracts, but they do not appear in the \"Credited seller\" dropdown and have no performance stats.",
    createBackOffice: "Create Back-Office",
  },
  DK: {
    reset: "Ryd felter", exit: "Afslut",
    // Anti-typo double-confirmation fields (Req. Fabrizio 22/02/2026)
    emailConfirmLabel: "Bekraeft e-mail (indtast igen)*",
    emailConfirmPlaceholder: "Indtast e-mail-adressen igen",
    emailConfirmOk: "\u2713 E-mail-adresserne stemmer overens",
    emailConfirmMismatch: "\u26A0 E-mail-adresserne stemmer ikke overens",
    phoneConfirmLabel: "Bekraeft mobil (indtast igen)*",
    phoneConfirmPlaceholder: "Indtast telefonnummeret igen",
    phoneConfirmOk: "\u2713 Telefonnumrene stemmer overens",
    phoneConfirmMismatch: "\u26A0 Telefonnumrene stemmer ikke overens",
    resetConfirm: "Vil du virkelig rydde alle udfyldte felter?",
    exitConfirm: "Forlade formularen? Ugemte aendringer vil ga tabt.",
    dealerFormSubtitle: "Felterne aktiveres gradvist, efterhanden som du udfylder dem.",
    creatingCustomerIn: "Du opretter en kunde i",
    changeCountry: "Skift land",
    customerCountry: "Kundens land",
    recent: "Seneste",
    recentCountries: "Seneste lande",
    allCountries: "Alle lande",
    confirm: "OK",
    customerType: "Kundetype",
    private: "Privatperson",
    business: "Virksomhed",
    privateIdentity: "Personlige oplysninger",
    businessIdentity: "Virksomhedsoplysninger",
    companyName: "Virksomhedsnavn",
    formatHint: "Format",
    vehicleData: "Koretojsdata",
    vinSuggestion: "NHTSA-forslag (VIN)",
    vinNotRecognised: "VIN ikke genkendt af NHTSA — indtast venligst maerke og model manuelt.",
    vinDecodeFailed: "VIN-afkodningstjenesten midlertidigt utilgaengelig",
    vinApplied: "Maerke og model udfyldt fra VIN",
    apply: "Anvend",
    ignore: "Ignorer",
    viesTooltip: "Online verificering via EU VIES",
    viesFound: "Virksomhedsdata fundet pa VIES",
    viesNotFound: "Momsnummer ikke fundet pa VIES",
    viesNotSupported: "VIES tilgaengelig kun for EU-lande",
    viesUnavailable: "VIES-tjenesten midlertidigt utilgaengelig",
    viesApplied: "VIES-data anvendt pa formularen",
    viesError: "VIES-verificeringsfejl",
    vatRequiredFirst: "Indtast venligst momsnummer forst",
    completeAllSteps: "Udfyld alle obligatoriske felter for at fortsaette",
    vinValidOk: "Gyldigt VIN (checksum OK)",
    vinValidEU: "Gyldigt VIN-format (EU)",
    vinSuspiciousRun: "Mistaenkeligt VIN: for mange identiske tegn i traek",
    vinChecksumFail: "Ugyldig VIN-checksum: kontrolcifferet i position 9 stemmer ikke",
    vinForbiddenChar: "VIN indeholder ugyldige tegn (I, O, Q)",
    vinBadLength: "VIN skal vaere 17 tegn langt",
    vinVerified: "VIN verificeret (NHTSA)",
    vinCheckDigitMismatch: "Kontrolciffer stemmer ikke",
    vehicleOriginLabel: "Koretoj",
    differentFromCustomer: "land afviger fra kunde",
    vehicleCountryMismatchTitle: "Koretojets land (",
    vehicleCountryMismatchVsCustomer: ") afviger fra kundens land ("
  ,
    taxCodeUiLabel: "Skattenummer",
    vatNumberUiLabel: "Momsnummer",
    validSuffix: "gyldigt",
    optional: "Valgfri",
    customerEmailLabel: "Kundens e-mail",
    vinChassisLabel: "VIN (Chassis)",
    vrnPlateLabel: "Registreringsnummer",
    brandLabel: "Maerke",
    modelLabel: "Model",
    confirmDeleteCustomer: "Slet kunden {name} ({email})?",
    customerDeletedSuccess: "Kunde slettet",
    customerDeleteError: "Fejl ved sletning af kunde",
    enterValidNumber: "Indtast venligst et gyldigt nummer",
    viewSignedReadonly: "Vis data (underskrevet, skrivebeskyttet)",
    editCustomer: "Rediger kunde",
    deleteCustomerOnlyUnsigned: "Slet kunde (kun hvis ikke underskrevet)",
    deactivateAction: "Deaktiver",
    activateAction: "Aktiver",
    deleteAction: "Slet",
    salesTeamPlaceholder: "f.eks. Salg Nord",
    thisMonth: "Denne maned",
    last7days: "Sidste 7 dage",
    last30daysShort: "Sidste 30 dage",
    last6MonthsTrend: "Trend sidste 6 maneder",
    topPerformerOfMonth: "Manedens bedste praesterer",
    monthHeader: "Maned",
    networkSummary: "Netvaerksoversigt",
    globalMonthlyTarget: "Globalt manedligt mal",
  
    mismatchTitle: "Kunder med land til gennemgang",
    mismatchBodyIntro: "I de seneste 30 dage har du oprettet",
    mismatchBodyMiddle: "kunder, hvoraf",
    mismatchBodyEnd: "har et land der adskiller sig fra det foreslaaede af moms eller telefonprefix. Ret med et klik.",
    mismatchCleanTitle: "Kvalitet landdata: ✅ Godt arbejde",
    mismatchCleanBody: "Alle {n} kunder fra de seneste 30 dage har et land konsistent med moms/telefon.",
    mismatchCurrent: "Nuvaerende:",
    mismatchSourceVat: "fra moms",
    mismatchSourcePhone: "fra telefon",
    mismatchFixBtn: "Ret",
    mismatchConfirmQuestion: "Bekraeft landeaendring til",
    mismatchReasonPlaceholder: "Aarsag til korrektion (valgfri)",
    mismatchSaving: "Gemmer...",
    mismatchConfirmFix: "Bekraeft korrektion",
    mismatchCancel: "Annuller",
    mismatchCountryUpdated: "Land opdateret:",
    mismatchCorrectionFailed: "Korrektionsfejl",
    mismatchCorrectionReasonDefault: "Rettet via Mismatch-widget (forhandler)",
    cannotDeleteContractSigned: "Kan ikke slette: kontrakt allerede underskrevet",
    resendActivationEmail: "Send aktiverings-email igen",
  
    fpSessionInvalid: "Ugyldig session",
    fpMissingToken: "Adgangstoken mangler.",
    fpBackToLogin: "Tilbage til login",
    fpPasswordTooShort: "Det nye kodeord skal vaere mindst 10 tegn langt.",
    fpPasswordsMismatch: "Kodeordene matcher ikke.",
    fpSameAsTemp: "Det nye kodeord kan ikke vaere det samme som det midlertidige.",
    fpSuccess: "Kodeord opdateret. Log ind igen.",
    fpUpdateFailed: "Kunne ikke opdatere kodeord.",
    fpTitle: "Opret dit personlige kodeord",
    fpSubtitle: "Ved forste login skal du erstatte det midlertidige kodeord modtaget pr. e-mail med et nyt personligt.",
    fpTempLabel: "Midlertidigt kodeord (det modtaget pr. e-mail)",
    fpNewLabel: "Nyt kodeord (min. 10 tegn)",
    fpConfirmLabel: "Bekraeft nyt kodeord",
    fpUpdating: "Opdaterer…",
    fpSetBtn: "Indstil nyt kodeord",
    fpSecurityNotice: "Af sikkerhedsmaessige aarsager skal du logge ind igen med det nye kodeord.",
    sellerCreditedLabel: "Credited seller",
    sellerCreditedPlaceholder: "Select the seller...",
    sellerCreditedManagerSuffix: "Owner",
    sellerCreditedHintNoSellers: "You have not added any sellers yet. You can credit this customer to yourself or create a seller from the \"Sellers\" tab.",
    backOfficeUserLabel: "Back-Office user (administrative staff)",
    backOfficeUserHint: "Back-Office users can create customers on behalf of sellers and monitor all contracts, but they do not appear in the \"Credited seller\" dropdown and have no performance stats.",
    createBackOffice: "Create Back-Office",
  },
  CZ: {
    reset: "Vymazat pole", exit: "Konec",
    // Anti-typo double-confirmation fields (Req. Fabrizio 22/02/2026)
    emailConfirmLabel: "Potvrdte email (napiste znovu)*",
    emailConfirmPlaceholder: "Napiste znovu emailovou adresu",
    emailConfirmOk: "\u2713 Emailove adresy se shoduji",
    emailConfirmMismatch: "\u26A0 Emailove adresy se neshoduji",
    phoneConfirmLabel: "Potvrdte mobil (napiste znovu)*",
    phoneConfirmPlaceholder: "Napiste znovu telefonni cislo",
    phoneConfirmOk: "\u2713 Telefonni cisla se shoduji",
    phoneConfirmMismatch: "\u26A0 Telefonni cisla se neshoduji",
    resetConfirm: "Opravdu chcete vymazat vsechna vyplnena pole?",
    exitConfirm: "Opustit formular? Neulozene zmeny budou ztraceny.",
    dealerFormSubtitle: "Pole se aktivuji postupne, jak je vyplnujete.",
    creatingCustomerIn: "Vytvarite zakaznika v",
    changeCountry: "Zmenit zemi",
    customerCountry: "Zeme zakaznika",
    recent: "Nedavne",
    recentCountries: "Nedavne zeme",
    allCountries: "Vsechny zeme",
    confirm: "OK",
    customerType: "Typ zakaznika",
    private: "Soukroma osoba",
    business: "Firma",
    privateIdentity: "Osobni udaje",
    businessIdentity: "Udaje firmy",
    companyName: "Nazev firmy",
    formatHint: "Format",
    vehicleData: "Udaje vozidla",
    vinSuggestion: "Navrh NHTSA (VIN)",
    vinNotRecognised: "NHTSA neidentifikovala VIN — zadejte znacku a model rucne.",
    vinDecodeFailed: "Sluzba dekodovani VIN je docasne nedostupna",
    vinApplied: "Znacka a model doplneny z VIN",
    apply: "Pouzit",
    ignore: "Ignorovat",
    viesTooltip: "Online overeni pres EU VIES",
    viesFound: "Udaje firmy nalezeny ve VIES",
    viesNotFound: "DIC nebylo nalezeno ve VIES",
    viesNotSupported: "VIES dostupny pouze pro zeme EU",
    viesUnavailable: "Sluzba VIES je docasne nedostupna",
    viesApplied: "Data VIES pouzita do formulare",
    viesError: "Chyba overeni VIES",
    vatRequiredFirst: "Nejprve zadejte DIC",
    completeAllSteps: "Vyplnte vsechna povinna pole pro pokracovani",
    vinValidOk: "Platne VIN (kontrolni soucet OK)",
    vinValidEU: "Platny format VIN (EU)",
    vinSuspiciousRun: "Podezrele VIN: prilis mnoho identickych znaku za sebou",
    vinChecksumFail: "Neplatny kontrolni soucet VIN: kontrolni cislice na pozici 9 nesouhlasi",
    vinForbiddenChar: "VIN obsahuje nepovolene znaky (I, O, Q)",
    vinBadLength: "VIN musi mit 17 znaku",
    vinVerified: "VIN overen (NHTSA)",
    vinCheckDigitMismatch: "Kontrolni cislice nesouhlasi",
    vehicleOriginLabel: "Vozidlo",
    differentFromCustomer: "zeme se lisi od zakaznika",
    vehicleCountryMismatchTitle: "Zeme vozidla (",
    vehicleCountryMismatchVsCustomer: ") se lisi od zeme zakaznika ("
  ,
    taxCodeUiLabel: "Danove cislo",
    vatNumberUiLabel: "DIC",
    validSuffix: "platne",
    optional: "Volitelne",
    customerEmailLabel: "E-mail zakaznika",
    vinChassisLabel: "VIN (Karoserie)",
    vrnPlateLabel: "Registracni znacka",
    brandLabel: "Znacka",
    modelLabel: "Model",
    confirmDeleteCustomer: "Smazat zakaznika {name} ({email})?",
    customerDeletedSuccess: "Zakaznik smazan",
    customerDeleteError: "Chyba pri mazani zakaznika",
    enterValidNumber: "Zadejte platne cislo",
    viewSignedReadonly: "Zobrazit data (podepsano, jen pro cteni)",
    editCustomer: "Upravit zakaznika",
    deleteCustomerOnlyUnsigned: "Smazat zakaznika (pouze pokud nepodepsano)",
    deactivateAction: "Deaktivovat",
    activateAction: "Aktivovat",
    deleteAction: "Smazat",
    salesTeamPlaceholder: "napr. Prodej Sever",
    thisMonth: "Tento mesic",
    last7days: "Poslednich 7 dni",
    last30daysShort: "Poslednich 30 dni",
    last6MonthsTrend: "Trend poslednich 6 mesicu",
    topPerformerOfMonth: "Nejlepsi zamestnance mesice",
    monthHeader: "Mesic",
    networkSummary: "Prehled site",
    globalMonthlyTarget: "Globalni mesicni cil",
  
    mismatchTitle: "Zakaznici se zemi k revizi",
    mismatchBodyIntro: "V poslednich 30 dnech jste vytvoril",
    mismatchBodyMiddle: "zakazniku, z toho",
    mismatchBodyEnd: "ma zem odlisnou od te navrzene DPH nebo telefonni predvolbou. Opravte jednim kliknutim.",
    mismatchCleanTitle: "Kvalita zemskych dat: ✅ Skvela prace",
    mismatchCleanBody: "Vsech {n} zakazniku z poslednich 30 dni ma zem konzistentni s DPH/telefonem.",
    mismatchCurrent: "Aktualni:",
    mismatchSourceVat: "z DPH",
    mismatchSourcePhone: "z telefonu",
    mismatchFixBtn: "Opravit",
    mismatchConfirmQuestion: "Potvrdit zmenu zeme na",
    mismatchReasonPlaceholder: "Duvod opravy (volitelne)",
    mismatchSaving: "Ukladani...",
    mismatchConfirmFix: "Potvrdit opravu",
    mismatchCancel: "Zrusit",
    mismatchCountryUpdated: "Zem aktualizovana:",
    mismatchCorrectionFailed: "Chyba opravy",
    mismatchCorrectionReasonDefault: "Opraveno pres widget Mismatch (prodejce)",
    cannotDeleteContractSigned: "Nelze smazat: smlouva jiz podepsana",
    resendActivationEmail: "Znovu odeslat aktivacni e-mail",
  
    fpSessionInvalid: "Neplatna relace",
    fpMissingToken: "Pristupovy token chybi.",
    fpBackToLogin: "Zpet na prihlaseni",
    fpPasswordTooShort: "Nove heslo musi mit nejmene 10 znaku.",
    fpPasswordsMismatch: "Hesla se neshoduji.",
    fpSameAsTemp: "Nove heslo nemuze byt stejne jako docasne.",
    fpSuccess: "Heslo aktualizovano. Prihlaste se znovu.",
    fpUpdateFailed: "Nelze aktualizovat heslo.",
    fpTitle: "Vytvorte si osobni heslo",
    fpSubtitle: "Pri prvnim prihlaseni musite nahradit docasne heslo prijate e-mailem novym osobnim heslem.",
    fpTempLabel: "Docasne heslo (to prijate e-mailem)",
    fpNewLabel: "Nove heslo (min. 10 znaku)",
    fpConfirmLabel: "Potvrdte nove heslo",
    fpUpdating: "Aktualizace…",
    fpSetBtn: "Nastavit nove heslo",
    fpSecurityNotice: "Z bezpecnostnich duvodu se po dokonceni musite znovu prihlasit s novym heslem.",
    sellerCreditedLabel: "Credited seller",
    sellerCreditedPlaceholder: "Select the seller...",
    sellerCreditedManagerSuffix: "Owner",
    sellerCreditedHintNoSellers: "You have not added any sellers yet. You can credit this customer to yourself or create a seller from the \"Sellers\" tab.",
    backOfficeUserLabel: "Back-Office user (administrative staff)",
    backOfficeUserHint: "Back-Office users can create customers on behalf of sellers and monitor all contracts, but they do not appear in the \"Credited seller\" dropdown and have no performance stats.",
    createBackOffice: "Create Back-Office",
  },
  GR: {
    reset: "Apokatastasi pedion", exit: "Eksodos",
    // Anti-typo double-confirmation fields (Req. Fabrizio 22/02/2026)
    emailConfirmLabel: "Epibebaiwste email (pliktrologiste xana)*",
    emailConfirmPlaceholder: "Pliktrologiste xana ti dievthinsi email",
    emailConfirmOk: "\u2713 Ta email tairiazoun",
    emailConfirmMismatch: "\u26A0 Ta email den tairiazoun",
    phoneConfirmLabel: "Epibebaiwste kinito (pliktrologiste xana)*",
    phoneConfirmPlaceholder: "Pliktrologiste xana ton arithmo tilefwnou",
    phoneConfirmOk: "\u2713 Oi arithmoi tairiazoun",
    phoneConfirmMismatch: "\u26A0 Oi arithmoi den tairiazoun",
    resetConfirm: "Thelete pragmatika na adeiasete ola ta sympliromena pedia?",
    exitConfirm: "Na fyge to entypo? Oi mi apothikevenes allages tha xathoun.",
    dealerFormSubtitle: "Ta pedia energopioiountai stadiaka kathos ta sympleronete.",
    creatingCustomerIn: "Dimioyrgeite enan pelati stin",
    changeCountry: "Allagi choras",
    customerCountry: "Chora tou pelati",
    recent: "Prosfata",
    recentCountries: "Prosfates chores",
    allCountries: "Oles oi chores",
    confirm: "OK",
    customerType: "Typos pelati",
    private: "Idiotis",
    business: "Etaireia",
    privateIdentity: "Prosopika stoicheia",
    businessIdentity: "Stoicheia etaireias",
    companyName: "Eponymia etaireias",
    formatHint: "Morfi",
    vehicleData: "Stoicheia ochimatos",
    vinSuggestion: "Protasi NHTSA (VIN)",
    vinNotRecognised: "To VIN den anagnoristhike apo to NHTSA — eisagete marka kai montelo cheirokineta.",
    vinDecodeFailed: "Yperysia apokodikopoiisis VIN proswrina min diathesimi",
    vinApplied: "Marka kai montelo sympliromena apo to VIN",
    apply: "Efarmogi",
    ignore: "Agnoia",
    viesTooltip: "Diadiktyaki epalitheysi mesw EU VIES",
    viesFound: "Stoicheia etaireias vrethikan sto VIES",
    viesNotFound: "Arithmos FPA den vrethike sto VIES",
    viesNotSupported: "To VIES einai diathesimo mono gia chores tis EE",
    viesUnavailable: "Yperysia VIES proswrina min diathesimi",
    viesApplied: "Stoicheia VIES efarmosthikan sti forma",
    viesError: "Sfalma epalitheysis VIES",
    vatRequiredFirst: "Parakaloume eisagete prota ton arithmo FPA",
    completeAllSteps: "Sympliroste ola ta apaitoumena pedia gia na synechisete",
    vinValidOk: "Egyro VIN (athrismatos elenchou OK)",
    vinValidEU: "Egyri morfi VIN (EE)",
    vinSuspiciousRun: "Ipopto VIN: para polla idia diadochika charaktires",
    vinChecksumFail: "Mi egyro athrismatos elenchou VIN: to psifio elenchou stin thesi 9 den syyneferei",
    vinForbiddenChar: "To VIN periechei mi epitreptous charaktires (I, O, Q)",
    vinBadLength: "To VIN prepei na einai 17 charaktires",
    vinVerified: "VIN epaliyeftike (NHTSA)",
    vinCheckDigitMismatch: "Psifio elenchou den syyneferei",
    vehicleOriginLabel: "Ochima",
    differentFromCustomer: "chora diaferei apo pelati",
    vehicleCountryMismatchTitle: "Chora ochimatos (",
    vehicleCountryMismatchVsCustomer: ") diaferei apo chora pelati ("
  ,
    taxCodeUiLabel: "Forologikos kodikas",
    vatNumberUiLabel: "Arithmos FPA",
    validSuffix: "egyro",
    optional: "Proairetiko",
    customerEmailLabel: "Email pelati",
    vinChassisLabel: "VIN (Sasi)",
    vrnPlateLabel: "Arithmos kyklophorias",
    brandLabel: "Marka",
    modelLabel: "Montelo",
    confirmDeleteCustomer: "Diagrafi pelati {name} ({email})?",
    customerDeletedSuccess: "Pelatis diegrafhike",
    customerDeleteError: "Sfalma diagrafis pelati",
    enterValidNumber: "Eisagete enan egyro arithmo",
    viewSignedReadonly: "Provoli dedomenon (ipogegrammeno, mono anagnosi)",
    editCustomer: "Epexergasia pelati",
    deleteCustomerOnlyUnsigned: "Diagrafi pelati (mono an den einai ipogegrammeno)",
    deactivateAction: "Apenergopoiisi",
    activateAction: "Energopoiisi",
    deleteAction: "Diagrafi",
    salesTeamPlaceholder: "p.ch. Poliseis Voreias",
    thisMonth: "Aytos o minas",
    last7days: "Teleyaies 7 imeres",
    last30daysShort: "Teleyaies 30 imeres",
    last6MonthsTrend: "Tasi teleyaion 6 minon",
    topPerformerOfMonth: "Koryphaios apodotis tou mina",
    monthHeader: "Minas",
    networkSummary: "Synopsi diktyou",
    globalMonthlyTarget: "Sfairikos miniaios stochos",
  
    mismatchTitle: "Pelates me chora gia elenchos",
    mismatchBodyIntro: "Tis teleyaies 30 imeres echete dimioyrgisei",
    mismatchBodyMiddle: "pelates, ek ton opoion",
    mismatchBodyEnd: "echoun mia chora diaforetiki apo aytin pou protinetai apo FPA i prothima tilefonou. Diorthose me ena klik.",
    mismatchCleanTitle: "Poiotita stoicheion choras: ✅ Excellent",
    mismatchCleanBody: "Oloi oi {n} pelates ton teleytaion 30 imeron echoun chora symfoni me FPA/tilephono.",
    mismatchCurrent: "Trechon:",
    mismatchSourceVat: "apo FPA",
    mismatchSourcePhone: "apo tilephono",
    mismatchFixBtn: "Diortho",
    mismatchConfirmQuestion: "Epibebaiosi allagis choras se",
    mismatchReasonPlaceholder: "Logos diorthosis (proairetiko)",
    mismatchSaving: "Apothikevsi...",
    mismatchConfirmFix: "Epibebaiosi diorthosis",
    mismatchCancel: "Akirosi",
    mismatchCountryUpdated: "Chora ananeothike:",
    mismatchCorrectionFailed: "Sfalma diorthosis",
    mismatchCorrectionReasonDefault: "Diorthothike mesw widget Mismatch (antiprosopo)",
    cannotDeleteContractSigned: "Den einai dynaton na diagrafi: symvasi idi ipogegrameni",
    resendActivationEmail: "Epanapostoli email energopoiisis",
  
    fpSessionInvalid: "Akiri synedria",
    fpMissingToken: "Lipo prosvasis token.",
    fpBackToLogin: "Pisō sti syndesi",
    fpPasswordTooShort: "O neos kodikos prepei na echei tooulachiston 10 charakteres.",
    fpPasswordsMismatch: "Oi kodikoi den symfonoun.",
    fpSameAsTemp: "O neos kodikos den mporei na einai idios me ton prosorino.",
    fpSuccess: "Kodikos ananeothike. Syndethite xana.",
    fpUpdateFailed: "Den itan dynaton na enimerothei o kodikos.",
    fpTitle: "Dimiourgiste ton prosopiko sas kodiko",
    fpSubtitle: "Sti proti synedria prepei na antikatastisete ton prosorino kodiko pou laváte mesa apo email me enan neo prosopiko.",
    fpTempLabel: "Prosorinos kodikos (aytos pou lavate mesa apo email)",
    fpNewLabel: "Neos kodikos (toy. 10 charakteres)",
    fpConfirmLabel: "Epibebaiosi neou kodikou",
    fpUpdating: "Enimerwsi…",
    fpSetBtn: "Orismós neou kodikou",
    fpSecurityNotice: "Gia logous asfaleias, sto telos tha sas zitithei na syndethite xana me ton neo kodiko.",
    sellerCreditedLabel: "Credited seller",
    sellerCreditedPlaceholder: "Select the seller...",
    sellerCreditedManagerSuffix: "Owner",
    sellerCreditedHintNoSellers: "You have not added any sellers yet. You can credit this customer to yourself or create a seller from the \"Sellers\" tab.",
    backOfficeUserLabel: "Back-Office user (administrative staff)",
    backOfficeUserHint: "Back-Office users can create customers on behalf of sellers and monitor all contracts, but they do not appear in the \"Credited seller\" dropdown and have no performance stats.",
    createBackOffice: "Create Back-Office",
  },
};

// CH = Swiss German → reuse DE pack
DEALER_FORM_I18N.CH = { ...DEALER_FORM_I18N.DE };
// GBZ = Gibraltar → reuse UK pack
DEALER_FORM_I18N.GBZ = { ...DEALER_FORM_I18N.UK };
// IRL = Ireland → reuse UK pack
DEALER_FORM_I18N.IRL = { ...DEALER_FORM_I18N.UK };
// BE = Belgian French → reuse FR pack
DEALER_FORM_I18N.BE = { ...DEALER_FORM_I18N.FR };

/** Get the form translation pack for a given country code (defaults to IT). */
export const getDealerFormI18n = (code) => DEALER_FORM_I18N[code?.toUpperCase()] || DEALER_FORM_I18N.IT;

export default DEALER_FORM_I18N;
